/* Lightweight i18n with 5 languages + locale persistence. */
import React, { createContext, useContext, useEffect, useState, useMemo } from 'react';

const dict = {
  fr: {
    'nav.home': 'Accueil',
    'nav.map': 'Map FH6',
    'nav.convoys': 'Convois',
    'nav.messages': 'Messages',
    'messages.title': 'Messages',
    'messages.tab.dms': 'Discussions',
    'messages.tab.friends': 'Amis',
    'messages.empty_threads': 'Aucune discussion. Ajoute un ami pour démarrer.',
    'messages.empty_conv': 'Envoie le premier message.',
    'messages.select_conv': 'Sélectionne une discussion ou un ami.',
    'messages.placeholder': 'Ton message...',
    'messages.search_user': 'Chercher un joueur...',
    'messages.pending_in': 'Demandes reçues',
    'messages.friends_count': 'Amis',
    'messages.no_friends': "Aucun ami pour l'instant.",
    'messages.request_sent': "Demande d'ami envoyée",
    'friend.add': "Ajouter",
    'friend.pending': 'En attente',
    'friend.respond': 'Répondre',
    'friend.message': 'Message',
    'notif.friend_request': "t'a envoyé une demande d'ami",
    'chat.title': 'Messagerie',
    'chat.open': 'Ouvrir la messagerie',
    'chat.full_view': 'Tout voir',
    'chat.friends_convoys': 'Amis & convois',
    'chat.my_convoy': 'Mon convoi',
    'chat.pilots': 'pilotes',
    'chat.open_short': 'Ouvrir',
    'chat.friend_requests': "Demandes d'amis",
    'chat.friends': 'Amis',
    'chat.no_friends': "Aucun ami pour l'instant.",
    'chat.following': 'Joueurs suivis',
    'chat.unread_messages': 'Messages non lus',
    'chat.quick.messages': 'Messagerie',
    'chat.quick.messages_sub': 'Messages privés',
    'chat.quick.convoy': 'Tchat du convoi',
    'chat.quick.convoy_none': 'Aucun convoi actif',
    'welcome.title': 'Bienvenue sur Horizon.Meet&Cruise',
    'welcome.subtitle': "Rejoins la communauté pour marquer tes spots, lancer des car meets et rouler en convoi avec d'autres pilotes FH6.",
    'welcome.register': 'Créer un compte',
    'welcome.login': "J'ai déjà un compte",
    'welcome.later': 'Plus tard',
    'composer.add_image': 'Ajouter une image',
    'composer.image_only': 'Images uniquement',
    'composer.too_large': 'Fichier trop volumineux (8 Mo max)',
    'public_profile.spots_of': 'Les spots de',
    'public_profile.no_spots': 'Aucun spot pour le moment.',
    'convoys.host.manage': 'Gérer',
    'convoys.host.kick_member': 'Exclure du convoi',
    'convoys.host.transfer_to': 'Transférer l\u2019hôte à',
    'convoys.host.kick_confirm_title': 'Exclure ce joueur ?',
    'convoys.host.kick_confirm_body': 'Confirmer l\u2019exclusion de',
    'convoys.host.transfer_confirm_title': 'Transférer le rôle d\u2019hôte ?',
    'convoys.host.transfer_confirm_body': 'Transférer le rôle à',
    'convoys.host.kicked': 'Joueur exclu',
    'convoys.host.transferred': 'Hôte transféré',
    'convoys.host.banned': 'Bannis',
    'convoys.host.unban': 'Réintégrer',
    'convoys.host.unbanned': 'Joueur réintégré',
    'map.fullscreen': 'Plein écran',
    'map.exit_fullscreen': 'Quitter le plein écran',
    'map.signal_carmeet': 'Signaler un Car Meet',
    'map.live': 'live',
    'map.cat.live_carmeet': 'Car Meet (live)',
    'map.cat.viewpoint': 'Point de vue',
    'map.cat.parking': 'Parking',
    'map.cat.gas': 'Station essence',
    'map.cat.spot': 'Spot',
    'map.cat.s365': '365',
    'addspot.cat.viewpoint': 'Point de vue',
    'addspot.cat.viewpoint_sub': 'Vue panoramique',
    'addspot.cat.parking': 'Parking',
    'addspot.cat.parking_sub': "Lieu de stationnement",
    'addspot.cat.gas': 'Station essence',
    'addspot.cat.gas_sub': 'Ravitaillement / repos',
    'addspot.cat.spot': 'Spot',
    'addspot.cat.spot_sub': 'Lieu intéressant',
    'addspot.cat.s365': '365',
    'addspot.cat.s365_sub': "Boutique ouverte 24/7",
    'spot.start_livemeet': 'Lancer un car meet live ici',
    'spot.live_here': 'Car meets live ici',
    'livemeet.locked_on_spot': 'Position du spot sélectionné',
    'livemeet.joined_convoy': 'Demande de convoi envoyée',
    'livemeet.convoy_full': 'Convoi complet',
    'livemeet.join_convoy': 'Demander à rejoindre',
    'livemeet.stop_btn': 'Arrêter le car meet live',
    'livemeet.confirm_stop': 'Arrêter ce car meet live ? Le convoi restera actif.',
    'livemeet.stopped': 'Car meet live arrêté',
    'convoys.chat.members_only': 'Réservé aux membres',
    'common.error': 'Une erreur est survenue',
    'map.by': 'par',
    'addspot.placeholder.title': 'Falaise du couchant',
    'addspot.placeholder.desc': "Heure dorée, accès facile, parking pour 5 voitures...",
    'admin.edit_spot.image': 'Capture',
    'admin.edit_spot.upload_cta': 'Remplacer la capture',
    'nav.leaderboard': 'Classement',
    'nav.media': 'Média',
    'media.label': 'Espace Média',
    'media.title': 'Partage tes meilleurs clichés',
    'media.subtitle': 'Photos, vidéos, clips YouTube/Twitch... Like, commente et réagis.',
    'media.tab.posts': 'Publications',
    'media.tab.screenshots': 'Screenshots',
    'media.tab.videos': 'Vidéos',
    'media.tab.from_spots': 'Depuis les spots',
    'media.new_post': 'Nouvelle publication',
    'media.new_post_desc': 'Publie une image, une vidéo ou un lien.',
    'media.kind.all': 'Tous',
    'media.kind.image': 'Image',
    'media.kind.video': 'Vidéo',
    'media.kind.link': 'Lien',
    'media.field.title': 'Titre',
    'media.field.description': 'Description',
    'media.field.upload_image': 'Image (max 8 Mo)',
    'media.field.upload_video': 'Vidéo',
    'media.field.external_url': 'URL YouTube / Twitch / Vimeo',
    'media.title_placeholder': 'Sunset drift à Kyoto',
    'media.desc_placeholder': 'Raconte la session...',
    'media.url_hint': 'Seuls les liens YouTube, Twitch et Vimeo sont acceptés.',
    'media.video_limit': 'max 30s, 25 Mo',
    'media.upload_ok': 'Fichier prêt',
    'media.image_too_large': 'Image trop grande (8 Mo max)',
    'media.video_too_large': 'Vidéo trop grande (25 Mo max)',
    'media.title_required': 'Donne un titre à ta publication',
    'media.publish': 'Publier',
    'media.created': 'Publication créée',
    'media.deleted': 'Publication supprimée',
    'media.confirm_delete': 'Supprimer cette publication ?',
    'media.reported': 'Signalement envoyé',
    'media.from_spot': 'Voir spot',
    'media.no_reactions_on_spot': 'Réactions disponibles sur les publications libres uniquement',
    'media.no_comments': 'Aucun commentaire pour le moment.',
    'media.comment_placeholder': 'Ajoute un commentaire...',
    'media.comment_login': 'Connecte-toi pour commenter',
    'media.send': 'Envoyer',
    'media.share': 'Partager',
    'media.add_reaction': 'Ajouter une réaction',
    'media.empty': 'Aucune publication pour le moment.',
    'media.sort.recent': 'Récent',
    'media.sort.popular': 'Plus likés',
    'media.sort.trending': 'Tendances (24h)',
    'media.scope.all': 'Tous',
    'media.scope.mine': 'Mes posts',
    'media.scope.friends': 'Mes amis',
    'leaderboard.title': 'Classement',
    'leaderboard.subtitle': 'Le top des pilotes de la communauté Horizon.Meet&Cruise.',
    'leaderboard.formula': 'Formule',
    'leaderboard.spots': 'Spots',
    'leaderboard.hosted': 'Hôte',
    'leaderboard.joined': 'Convois',
    'leaderboard.likes': 'Likes',
    'leaderboard.score': 'Score',
    'leaderboard.online_time': 'Temps en ligne',
    'leaderboard.driver': 'Pilote',
    'leaderboard.empty': 'Aucun pilote classé pour le moment.',
    'leaderboard.followers': 'Abonnés',
    'leaderboard.sort_by': 'Trier par',
    'follow.follow': 'Suivre',
    'follow.following': 'Suivi',
    'follow.followed': 'Pilote suivi',
    'follow.unfollowed': 'Pilote non suivi',
    'report.title': 'Signaler',
    'report.desc': 'Décris ce qui pose problème. Les admins examineront ton signalement.',
    'report.reason': 'Raison du signalement',
    'report.placeholder': 'Comportement inapproprié, spam, contenu offensant...',
    'report.submit': 'Envoyer le signalement',
    'report.sent': 'Signalement envoyé',
    'report.too_short': 'Raison trop courte (min 5 caractères)',
    'livemeet.title': 'Car Meet en direct',
    'livemeet.desc': 'Signale aux autres pilotes que tu organises un car meet là, maintenant.',
    'livemeet.field.title': 'Titre du meet',
    'livemeet.placeholder': 'Late night drift @ Tokyo',
    'livemeet.coords_set': 'Position prête',
    'livemeet.pick_on_map': 'Cliquer sur la carte pour choisir le point',
    'livemeet.pick_first': "D'abord, choisis un point sur la carte.",
    'livemeet.pick_banner': 'Clique sur la carte pour placer ton car meet',
    'livemeet.ttl_hint': 'Visible pendant 4h ou jusqu\u2019à ce que tu l\u2019arrêtes.',
    'livemeet.broadcast': 'Diffuser le meet',
    'livemeet.created': 'Car meet diffusé !',
    'livemeet.default_title': 'Car meet en cours',
    'livemeet.expires_at': 'Expire à',
    'livemeet.stop': 'Arrêter mon car meet',
    'livemeet.stop_confirm': 'Arrêter ton car meet en direct ?',
    'livemeet.stopped': 'Car meet arrêté',
    'livemeet.admin_delete': 'Supprimer (admin)',
    'livemeet.deleted': 'Car meet supprimé',
    'livemeet.field.convoy': 'Lier à un convoi',
    'livemeet.no_convoy': 'Aucun convoi lié',
    'livemeet.convoy_hint': 'Les pilotes pourront rejoindre ton convoi directement depuis la map.',
    'livemeet.choose_convoy': 'Choisir un convoi',
    'livemeet.must_create_convoy_title': 'Convoi requis',
    'livemeet.must_create_convoy_body': "Un car meet live doit obligatoirement être lié à un convoi. Crée d'abord un convoi pour pouvoir signaler ton meet.",
    'livemeet.go_create_convoy': 'Créer un convoi',
    'livemeet.mode.choice': 'Comment veux-tu lier ton car meet ?',
    'livemeet.mode.existing': 'Utiliser un de mes convois',
    'livemeet.mode.create': 'Créer un nouveau convoi',
    'livemeet.new_convoy_name': 'Nom du convoi',
    'livemeet.new_convoy_placeholder': 'Ex: Drift Sunset Crew',
    'livemeet.new_convoy_created': 'Convoi créé et lié',
    'livemeet.linked_convoy': 'Convoi associé',
    'livemeet.join_convoy': 'Rejoindre le convoi',
    'livemeet.joined_convoy': 'Convoi rejoint !',
    'livemeet.convoy_full': 'Convoi complet',
    'convoys.members': 'membres',
    'common.confirm': 'Confirmer',
    'common.cancel': 'Annuler',
    'nav.about': 'À propos',
    'nav.login': 'Connexion',
    'nav.logout': 'Se déconnecter',
    'nav.profile': 'Mon profil',
    'nav.admin': 'Modération',
    'auth.title.login': 'Connexion',
    'auth.title.register': 'Créer un compte',
    'auth.desc': 'Rejoins la communauté FH6. Place tes spots, like les meilleurs et commente.',
    'auth.tab.login': 'Connexion',
    'auth.tab.register': 'Inscription',
    'auth.name': 'Pseudo',
    'auth.email': 'Email',
    'auth.password': 'Mot de passe',
    'auth.submit.login': 'Se connecter',
    'auth.submit.register': "S'inscrire",
    'auth.discord': 'Continuer avec Discord',
    'auth.or': 'ou',
    'auth.welcome_back': 'Bienvenue !',
    'auth.account_created': 'Compte créé.',
    'auth.must_login': 'Connecte-toi pour continuer.',

    'hero.tag': 'Communauté · Spots · Convois · Photos',
    'hero.title.line1': 'La map de',
    'hero.title.line2': 'marquée par toi.',
    'hero.subtitle': "Marque les meilleurs spots de la map FH6, fais-les découvrir à la communauté, et lance tes propres car meets & convois en direct pour rouler ensemble.",
    'hero.cta.map': 'Ouvrir la map',
    'hero.cta.convoys': 'Voir les convois',
    'hero.cta.about': 'Comment ça marche',
    'hero.stats.map': 'Carte 4K',
    'hero.stats.map_sub': 'satellite officielle',
    'hero.stats.photos': 'Photo spots',
    'hero.stats.photos_sub': 'partagés',
    'hero.stats.meets': 'Car meets',
    'hero.stats.meets_sub': 'communautaires',
    'hero.stats.likes': 'Likes & avis',
    'hero.stats.likes_sub': 'Statistique',

    'landing.terrains.title1': 'Un terrain de jeu,',
    'landing.terrains.title2': 'trois univers.',
    'landing.terrains.subtitle': "Du sommet enneigé aux ports industriels, FH6 propose des biomes radicalement différents. Chaque coin a son spot. À toi de les marquer.",
    'landing.terrains.mountains.t': 'Sommets enneigés',
    'landing.terrains.mountains.d': 'Cols de montagne, drift sur neige, panoramas spectaculaires.',
    'landing.terrains.forests.t': 'Forêts & vallées',
    'landing.terrains.forests.d': 'Routes sinueuses entre les pins, ponts suspendus, rivières.',
    'landing.terrains.city.t': 'Métropole & port',
    'landing.terrains.city.d': 'Tunnels néon, autoroutes urbaines, docks industriels.',
    'landing.how.tag': 'Comment ça marche',
    'landing.how.title': 'Quatre étapes. Zéro friction.',
    'landing.how.s1.t': 'Ouvre la map',
    'landing.how.s1.d': 'Clique sur "Ouvrir la map" pour accéder à la carte interactive de FH6.',
    'landing.how.s2.t': 'Place un marqueur',
    'landing.how.s2.d': "Crée un spot (parking, point de vue, 365, etc.) avec screenshot. Tu peux ensuite lancer un car meet live directement depuis ce spot — ou en ouvrir un n'importe où sur la map en cliquant librement.",
    'landing.how.s3.t': 'Explore',
    'landing.how.s3.d': "Like, commente, rejoins un convoi, et balade-toi d'un spot à un autre pour découvrir les meilleurs coins postés par la communauté.",
    'landing.how.s4.t': 'Lance un convoi',
    'landing.how.s4.d': "Crée un convoi sur la page dédiée et roulez ensemble en temps réel. Important : ce site n'est pas relié au jeu — invite tes potes via Forza Horizon 6 directement.",
    'landing.creator.title': 'Soutien le créateur',
    'landing.creator.discord_join': 'Rejoindre le serveur',
    'landing.creator.subtitle': 'Retrouve Ochibi sur ses autres plateformes.',
    'landing.cta.enter': 'Ouvrir la map de FH6',
    'landing.featured.year': 'Summer · 2026',
    'landing.featured.cta': 'Ouvrir la map',

    'map.back_home': 'Accueil',
    'map.search_placeholder': 'Chercher un spot...',
    'map.filters': 'Filtres',
    'map.cat.carmeet': 'Car Meets',
    'map.cat.photo': 'Spots Photo',
    'map.spots_count': 'Spots',
    'map.empty_logged_in': 'Aucun spot. Sois le premier à en ajouter !',
    'map.empty_logged_out': 'Aucun spot. Connecte-toi pour ajouter un spot.',
    'map.tip': 'Active "Ajouter un spot" puis clique sur la carte à l\'endroit voulu.',
    'map.tip_strong': 'Ajouter un spot',
    'map.add_spot': 'Ajouter un spot',
    'map.cancel': 'Annuler',
    'map.click_to_place': 'Clique sur la carte pour placer ton spot',
    'map.legend.carmeet': 'Car Meet',
    'map.legend.photo': 'Photo Spot',
    'map.online_now': 'en ligne',
    'map.live_convoys': 'convois en cours',
    'map.hide_sidebar': 'Masquer les filtres',
    'map.show_sidebar': 'Afficher les filtres',

    'addspot.title': 'Nouveau spot',
    'addspot.desc': "Décris l'endroit et choisis sa catégorie. Tu peux ajouter un screenshot.",
    'addspot.cat.carmeet': 'Car Meet',
    'addspot.cat.carmeet_sub': 'Lieu de rassemblement',
    'addspot.cat.photo': 'Spot Photo',
    'addspot.cat.photo_sub': 'Point de vue / paysage',
    'addspot.field.title': 'Titre',
    'addspot.field.desc': 'Description (optionnel)',
    'addspot.upload.title': 'Screenshot (optionnel)',
    'addspot.upload.cta': 'Glisse ou clique pour uploader',
    'addspot.upload.hint': 'JPG · PNG · WEBP · 8MB max',
    'addspot.submit': 'Publier le spot',
    'addspot.created': 'Spot ajouté !',

    'spot.by': 'par',
    'spot.likes': 'likes',
    'spot.like_singular': 'like',
    'spot.comments_count': 'commentaire',
    'spot.comments_count_plural': 'commentaires',
    'spot.delete': 'Supprimer ce spot',
    'spot.moderate_admin': 'Modérer (admin)',
    'spot.deleted': 'Spot supprimé',
    'spot.confirm_delete': 'Supprimer ce spot ?',
    'spot.comments.title': 'Commentaires',
    'spot.comments.placeholder': 'Laisse un commentaire...',
    'spot.comments.placeholder_disabled': 'Connecte-toi pour commenter',
    'spot.comments.empty': 'Sois le premier à commenter.',
    'spot.comment.reply': 'Répondre',
    'spot.comment.cancel': 'Annuler',
    'spot.comment.like': "J'aime",
    'spot.comment.reply_to': 'Répondre à',
    'spot.comment.deleted': 'Commentaire supprimé',
    'spot.comment.confirm_delete': 'Supprimer ce commentaire ?',

    'convoys.title': 'Convois en cours',
    'convoys.subtitle': "Rejoins un convoi ou crée le tien. Partage le lien à tes potes pour qu'ils embarquent.",
    'convoys.create': 'Créer un convoi',
    'convoys.empty': "Aucun convoi pour l'instant. Sois le premier à en lancer un !",
    'convoys.online': 'joueurs en ligne',
    'convoys.online_others': 'autres',
    'convoys.members': 'membres',
    'convoys.join': 'Rejoindre',
    'convoys.joined': 'Rejoint',
    'convoys.leave': 'Quitter',
    'convoys.full': 'Complet',
    'convoys.share': 'Partager',
    'convoys.copied': 'Lien copié !',
    'convoys.host': 'Hôte',
    'convoys.season': 'Saison',
    'convoys.delete': 'Supprimer',
    'convoys.deleted': 'Convoi supprimé',
    'convoys.confirm_delete': 'Supprimer ce convoi ?',
    'convoys.scheduled': 'Prévu',
    'convoys.must_login_create': 'Connecte-toi pour créer un convoi.',
    'convoys.must_login_join': 'Connecte-toi pour rejoindre.',
    'convoys.launched': 'Convoi lancé !',
    'convoys.crew': 'Équipage',
    'convoys.discussion': 'Discussion',
    'convoys.chat.placeholder': 'Coordonne-toi avec les pilotes...',
    'convoys.chat.placeholder_disabled': 'Connecte-toi pour discuter',
    'convoys.chat.empty': "Aucun message pour l'instant.",
    'convoys.form.name': 'Nom du convoi',
    'convoys.form.desc': 'Description (objectif, voitures, niveau)',
    'convoys.form.max': 'Capacité max (hôte inclus)',
    'convoys.form.submit': 'Lancer le convoi',
    'convoys.not_found': 'Convoi introuvable',
    'convoys.joined_toast': 'Rejoint !',
    'convoys.request_sent': "Demande envoyée à l'hôte",
    'convoys.request_join': 'Demander à rejoindre',
    'convoys.pending_approval': "En attente d'approbation",
    'convoys.cancel_request': 'Annuler ma demande',
    'convoys.request_cancelled': 'Demande annulée',
    'convoys.member_accepted': 'Joueur accepté dans le convoi',
    'convoys.member_rejected': 'Demande refusée',
    'convoys.pending_requests': 'Demandes en attente',
    'convoys.accept': 'Accepter',
    'convoys.reject': 'Refuser',
    'notif.convoy_request': 'veut rejoindre',
    'notif.convoy_requests_plural': 'demandes pour',
    'notif.manage': 'Gérer',
    'notif.empty': 'Aucune notification',
    'notif.click_to_manage': 'Cliquer pour gérer',
    'notif.click_to_view': 'Cliquer pour voir le profil',
    'notif.see': 'Voir',
    'notif.mark_all_read': 'Tout marquer comme lu',
    'notif.mark_all_read_short': 'Tout lu',
    'notif.clear_all': 'Tout effacer',
    'nav.notifications': 'Notifications',
    'map.hide_all': 'Tout masquer',
    'map.show_all': 'Tout afficher',
    'landing.top_media.label': 'Trending',
    'landing.top_media.title': 'Les meilleurs clichés du moment',
    'landing.top_media.subtitle': 'Le top 3 le plus aimé par la communauté.',
    'landing.top_media.see_all': 'Voir tout le média',
    'landing.leaderboard.label': 'Top players',
    'landing.leaderboard.title': 'Classement de la communauté',
    'landing.leaderboard.subtitle': 'Score = hôte × 15 + convois × 5 + abonnés × 10 + heures en ligne × 2',
    'landing.leaderboard.see_all': 'Voir le classement complet',
    'public_profile.media.posts': 'Médias publiés',
    'public_profile.media.likes': 'Likes média',
    'public_profile.media.comments': 'Commentaires reçus',
    'public_profile.media.reactions': 'Réactions',
    'public_profile.publications': 'Publications',
    'convoys.left_toast': 'Quitté',

    'profile.title': 'Mon profil',
    'profile.member_of': 'Membre de Horizon.Meet&Cruise',
    'profile.go_map': 'Ajouter un spot',
    'profile.stats.spots': 'Spots créés',
    'profile.stats.meets': 'Car Meets',
    'profile.stats.photos': 'Photo Spots',
    'profile.stats.likes': 'Likes reçus',
    'profile.my_spots': 'Mes spots',
    'profile.contributions_singular': 'contribution sur la carte de FH6.',
    'profile.contributions_plural': 'contributions sur la carte de FH6.',
    'profile.empty.title': "Aucun spot pour l'instant",
    'profile.empty.desc': 'Lance-toi : ouvre la map et place ton premier car meet ou point photo.',
    'profile.empty.cta': 'Ouvrir la map',
    'profile.unavailable': 'Profil indisponible.',

    'admin.title': 'Modération',
    'admin.logged_as': 'Connecté en tant que',
    'admin.stats.users': 'Utilisateurs',
    'admin.stats.spots': 'Spots',
    'admin.stats.carmeet': 'Car Meets',
    'admin.stats.photo': 'Photo Spots',
    'admin.stats.comments': 'Commentaires',
    'admin.search': 'Filtrer par titre, auteur, email...',
    'admin.tab.spots': 'Spots',
    'admin.tab.comments': 'Commentaires',
    'admin.tab.users': 'Utilisateurs',
    'admin.confirm_delete_spot': 'Supprimer le spot',
    'admin.confirm_delete_comment': 'Supprimer ce commentaire ?',
    'admin.col.username': 'Pseudo',
    'admin.col.email': 'Email',
    'admin.col.role': 'Rôle',
    'admin.col.registered': 'Inscription',
    'admin.reply_marker': 'réponse',

        'landing.live.convoys': 'convois en cours',
    'landing.live.online': 'joueurs en ligne',
    'landing.convoys.title': 'Convois en direct',
    'landing.convoys.subtitle': "Rejoins un convoi qui démarre maintenant ou lance le tien depuis la page dédiée.",
    'landing.convoys.cta': 'Voir tous les convois',
    'landing.convoys.empty': "Aucun convoi actif. Lance le premier !",
    'landing.convoys.create': 'Créer un convoi',
        'gamertag.title': 'Ton pseudo in-game',
    'gamertag.desc': "Avant de continuer, indique ton pseudo Forza Horizon 6 pour que les autres pilotes puissent t'identifier dans le jeu. Tu pourras le modifier plus tard.",
    'gamertag.field': 'Pseudo in-game (Forza Horizon 6)',
    'gamertag.hint': '40 caractères max · ce sera ton nom affiché partout',
    'gamertag.save': 'Continuer',
    'gamertag.saved': 'Pseudo enregistré',
    'profile.avatar.change': 'Changer la photo',
    'profile.avatar.saved': 'Photo de profil mise à jour',
    'profile.socials.title': 'Comptes liés',
    'profile.socials.subtitle': 'Affiche tes comptes Discord, Twitch, YouTube et TikTok sur ton profil.',
    'profile.socials.placeholder.discord': 'discord_user#0001 ou tag',
    'profile.socials.placeholder.twitch': 'twitch.tv/ton_pseudo',
    'profile.socials.placeholder.youtube': 'youtube.com/@ta_chaine',
    'profile.socials.placeholder.tiktok': '@ton_pseudo_tiktok',
    'profile.socials.saved': 'Comptes mis à jour',
    'profile.socials.save': 'Enregistrer',
    'profile.edit.gamer_tag': 'Pseudo in-game',
    'profile.edit.name': 'Nom affiché',
    'profile.edit.save': 'Sauvegarder',
    'profile.edit.saved': 'Profil mis à jour',
    'admin.edit_spot': 'Modifier',
    'admin.edit_spot.title': 'Modifier le spot',
    'admin.edit_spot.save': 'Enregistrer',
    'admin.edit_spot.saved': 'Spot modifié',
    'common.save': 'Enregistrer',
    'common.cancel': 'Annuler',
    'common.delete': 'Supprimer',
    'common.loading': 'Chargement...',
    'common.error': 'Erreur',
    'common.season.spring': 'Printemps',
    'common.season.summer': 'Été',
    'common.season.autumn': 'Automne',
    'common.season.winter': 'Hiver',
    'lang.label': 'Langue',
  },
  en: {
    'nav.home': 'Home', 'nav.map': 'FH6 Map', 'nav.convoys': 'Convoys',
    'nav.messages': 'Messages',
    'messages.title': 'Messages',
    'messages.tab.dms': 'Chats',
    'messages.tab.friends': 'Friends',
    'messages.empty_threads': 'No chats yet. Add a friend to start.',
    'messages.empty_conv': 'Send the first message.',
    'messages.select_conv': 'Pick a chat or a friend.',
    'messages.placeholder': 'Your message...',
    'messages.search_user': 'Search a driver...',
    'messages.pending_in': 'Incoming requests',
    'messages.friends_count': 'Friends',
    'messages.no_friends': 'No friends yet.',
    'messages.request_sent': 'Friend request sent',
    'friend.add': 'Add',
    'friend.pending': 'Pending',
    'friend.respond': 'Respond',
    'friend.message': 'Message',
    'notif.friend_request': 'sent you a friend request',
    'chat.title': 'Messages',
    'chat.open': 'Open chat',
    'chat.full_view': 'Full view', 'nav.about': 'About',
    'chat.friends_convoys': 'Friends & convoys',
    'chat.my_convoy': 'My convoy',
    'chat.pilots': 'pilots',
    'chat.open_short': 'Open',
    'chat.friend_requests': 'Friend requests',
    'chat.friends': 'Friends',
    'chat.no_friends': 'No friends yet.',
    'chat.following': 'Following',
    'chat.unread_messages': 'Unread messages',
    'chat.quick.messages': 'Messages',
    'chat.quick.messages_sub': 'Private messages',
    'chat.quick.convoy': 'Convoy chat',
    'chat.quick.convoy_none': 'No active convoy',
    'welcome.title': 'Welcome to Horizon.Meet&Cruise',
    'welcome.subtitle': 'Join the community to mark your spots, launch car meets and convoy with other FH6 drivers.',
    'welcome.register': 'Create an account',
    'welcome.login': 'I already have an account',
    'welcome.later': 'Later',
    'composer.add_image': 'Add image', 'composer.image_only': 'Images only', 'composer.too_large': 'File too large (8MB max)',
    'public_profile.spots_of': "Spots by", 'public_profile.no_spots': 'No spots yet.',
    'convoys.host.manage': 'Manage', 'convoys.host.kick_member': 'Kick from convoy',
    'convoys.host.transfer_to': 'Transfer host to', 'convoys.host.kick_confirm_title': 'Kick this driver?',
    'convoys.host.kick_confirm_body': 'Confirm kick of', 'convoys.host.transfer_confirm_title': 'Transfer host role?',
    'convoys.host.transfer_confirm_body': 'Transfer the role to', 'convoys.host.kicked': 'Driver kicked',
    'convoys.host.transferred': 'Host transferred', 'convoys.host.banned': 'Banned',
    'convoys.host.unban': 'Allow back', 'convoys.host.unbanned': 'Driver allowed back',
    'map.fullscreen': 'Fullscreen', 'map.exit_fullscreen': 'Exit fullscreen',
    'map.signal_carmeet': 'Signal a Car Meet', 'map.live': 'live',
    'map.cat.live_carmeet': 'Car Meet (live)', 'map.cat.viewpoint': 'Viewpoint',
    'map.cat.parking': 'Parking', 'map.cat.gas': 'Gas station', 'map.cat.spot': 'Spot',
    'map.cat.s365': '365',
    'addspot.cat.viewpoint': 'Viewpoint', 'addspot.cat.viewpoint_sub': 'Panoramic view',
    'addspot.cat.parking': 'Parking', 'addspot.cat.parking_sub': 'Place to park',
    'addspot.cat.gas': 'Gas station', 'addspot.cat.gas_sub': 'Refuel / break',
    'addspot.cat.spot': 'Spot', 'addspot.cat.spot_sub': 'Cool place',
    'addspot.cat.s365': '365', 'addspot.cat.s365_sub': '24/7 convenience store',
    'spot.start_livemeet': 'Start a live car meet here',
    'spot.live_here': 'Live car meets here',
    'livemeet.locked_on_spot': 'Selected spot location',
    'livemeet.joined_convoy': 'Convoy request sent',
    'livemeet.convoy_full': 'Convoy full',
    'livemeet.join_convoy': 'Request to join',
    'livemeet.stop_btn': 'Stop live car meet',
    'livemeet.confirm_stop': 'Stop this live car meet? The convoy will stay active.',
    'livemeet.stopped': 'Live car meet stopped',
    'convoys.chat.members_only': 'Members only',
    'common.error': 'An error occurred',
    'map.by': 'by',
    'addspot.placeholder.title': 'Sunset Cliff', 'addspot.placeholder.desc': 'Golden hour, easy access, parking for 5 cars...',
    'admin.edit_spot.image': 'Screenshot', 'admin.edit_spot.upload_cta': 'Replace screenshot',
    'nav.leaderboard': 'Leaderboard',
    'nav.media': 'Media',
    'media.label': 'Media Hub',
    'media.title': 'Share your best shots',
    'media.subtitle': 'Photos, videos, YouTube/Twitch clips… Like, comment, react.',
    'media.tab.posts': 'Posts', 'media.tab.screenshots': 'Screenshots', 'media.tab.videos': 'Videos', 'media.tab.from_spots': 'From spots',
    'media.new_post': 'New post', 'media.new_post_desc': 'Publish an image, video or link.',
    'media.kind.all': 'All', 'media.kind.image': 'Image', 'media.kind.video': 'Video', 'media.kind.link': 'Link',
    'media.field.title': 'Title', 'media.field.description': 'Description',
    'media.field.upload_image': 'Image (max 8MB)', 'media.field.upload_video': 'Video',
    'media.field.external_url': 'YouTube / Twitch / Vimeo URL',
    'media.title_placeholder': 'Sunset drift in Kyoto',
    'media.desc_placeholder': 'Tell the story of this run...',
    'media.url_hint': 'Only YouTube, Twitch and Vimeo links are supported.',
    'media.video_limit': '30s max, 25MB',
    'media.upload_ok': 'File ready', 'media.image_too_large': 'Image too large (max 8MB)',
    'media.video_too_large': 'Video too large (max 25MB)',
    'media.title_required': 'Add a title to your post',
    'media.publish': 'Publish', 'media.created': 'Post created', 'media.deleted': 'Post deleted',
    'media.confirm_delete': 'Delete this post?', 'media.reported': 'Report submitted',
    'media.from_spot': 'View spot',
    'media.no_reactions_on_spot': 'Reactions are available on free posts only',
    'media.no_comments': 'No comments yet.',
    'media.comment_placeholder': 'Add a comment...', 'media.comment_login': 'Sign in to comment',
    'media.send': 'Send', 'media.share': 'Share',
    'media.add_reaction': 'Add reaction', 'media.empty': 'No posts yet.',
    'media.sort.recent': 'Recent', 'media.sort.popular': 'Most liked', 'media.sort.trending': 'Trending (24h)',
    'media.scope.all': 'Everyone', 'media.scope.mine': 'Mine', 'media.scope.friends': 'My friends',
    'leaderboard.title': 'Leaderboard', 'leaderboard.subtitle': 'Top drivers of the Horizon.Meet&Cruise community.',
    'leaderboard.formula': 'Formula', 'leaderboard.spots': 'Spots', 'leaderboard.hosted': 'Hosted',
    'leaderboard.joined': 'Convoys', 'leaderboard.likes': 'Likes', 'leaderboard.score': 'Score',
    'leaderboard.online_time': 'Online time',
    'leaderboard.driver': 'Driver', 'leaderboard.empty': 'No ranked drivers yet.',
    'leaderboard.followers': 'Followers', 'leaderboard.sort_by': 'Sort by',
    'follow.follow': 'Follow', 'follow.following': 'Following',
    'follow.followed': 'Now following', 'follow.unfollowed': 'Unfollowed',
    'report.title': 'Report', 'report.desc': 'Describe the problem. Admins will review your report.',
    'report.reason': 'Reason', 'report.placeholder': 'Inappropriate behavior, spam, offensive content...',
    'report.submit': 'Send report', 'report.sent': 'Report sent',
    'report.too_short': 'Reason too short (min 5 chars)',
    'livemeet.title': 'Live Car Meet', 'livemeet.desc': "Tell other drivers you're hosting a car meet right now.",
    'livemeet.field.title': 'Meet title', 'livemeet.placeholder': 'Late night drift @ Tokyo',
    'livemeet.coords_set': 'Position ready', 'livemeet.pick_on_map': 'Click the map to pick a spot',
    'livemeet.pick_first': 'First, pick a spot on the map.', 'livemeet.pick_banner': 'Click the map to place your car meet',
    'livemeet.ttl_hint': 'Visible for 4h or until you stop it.',
    'livemeet.broadcast': 'Broadcast meet', 'livemeet.created': 'Car meet broadcasted!',
    'livemeet.default_title': 'Car meet in progress',
    'livemeet.expires_at': 'Expires at', 'livemeet.stop': 'Stop my car meet',
    'livemeet.stop_confirm': 'Stop your live car meet?', 'livemeet.stopped': 'Car meet stopped',
    'livemeet.admin_delete': 'Delete (admin)', 'livemeet.deleted': 'Car meet deleted',
    'livemeet.field.convoy': 'Link a convoy', 'livemeet.no_convoy': 'No linked convoy',
    'livemeet.convoy_hint': 'Drivers will be able to join your convoy right from the map.',
    'livemeet.choose_convoy': 'Choose a convoy', 'livemeet.must_create_convoy_title': 'Convoy required',
    'livemeet.must_create_convoy_body': 'A live car meet must be linked to a convoy. Create one first to broadcast your meet.',
    'livemeet.go_create_convoy': 'Create a convoy',
    'livemeet.mode.choice': 'How do you want to link your meet?',
    'livemeet.mode.existing': 'Use one of my convoys',
    'livemeet.mode.create': 'Create a new convoy',
    'livemeet.new_convoy_name': 'Convoy name',
    'livemeet.new_convoy_placeholder': 'e.g. Drift Sunset Crew',
    'livemeet.new_convoy_created': 'Convoy created & linked',
    'livemeet.linked_convoy': 'Linked convoy', 'livemeet.join_convoy': 'Join convoy',
    'livemeet.joined_convoy': 'Convoy joined!', 'livemeet.convoy_full': 'Convoy full',
    'convoys.members': 'members',
    'common.confirm': 'Confirm', 'common.cancel': 'Cancel',
    'nav.login': 'Sign in', 'nav.logout': 'Sign out', 'nav.profile': 'My profile', 'nav.admin': 'Moderation',
    'auth.title.login': 'Sign in', 'auth.title.register': 'Create account',
    'auth.desc': 'Join the FH6 community. Drop your spots, like the best, and comment.',
    'auth.tab.login': 'Sign in', 'auth.tab.register': 'Sign up',
    'auth.name': 'Username', 'auth.email': 'Email', 'auth.password': 'Password',
    'auth.submit.login': 'Sign in', 'auth.submit.register': 'Sign up',
    'auth.discord': 'Continue with Discord', 'auth.or': 'or',
    'auth.welcome_back': 'Welcome!', 'auth.account_created': 'Account created.',
    'auth.must_login': 'Sign in to continue.',
    'hero.tag': 'Community · Spots · Convoys · Photos',
    'hero.title.line1': 'The map of', 'hero.title.line2': 'marked by you.',
    'hero.subtitle': 'Mark the best spots on the FH6 map, share them with the community, and launch your own live car meets & convoys to drive together.',
    'hero.cta.map': 'Open the map', 'hero.cta.convoys': 'Browse convoys', 'hero.cta.about': 'How it works',
    'hero.stats.map': '4K map', 'hero.stats.map_sub': 'official satellite',
    'hero.stats.photos': 'Photo spots', 'hero.stats.photos_sub': 'shared',
    'hero.stats.meets': 'Car meets', 'hero.stats.meets_sub': 'community',
    'hero.stats.likes': 'Likes & feedback', 'hero.stats.likes_sub': 'Stats',
    'landing.terrains.title1': 'One playground,', 'landing.terrains.title2': 'three universes.',
    'landing.terrains.subtitle': 'From snowy peaks to industrial ports, FH6 offers radically different biomes. Every corner has its spot. Mark them all.',
    'landing.terrains.mountains.t': 'Snowy peaks', 'landing.terrains.mountains.d': 'Mountain passes, snow drifts, spectacular views.',
    'landing.terrains.forests.t': 'Forests & valleys', 'landing.terrains.forests.d': 'Winding roads through pines, suspended bridges, rivers.',
    'landing.terrains.city.t': 'City & port', 'landing.terrains.city.d': 'Neon tunnels, urban highways, industrial docks.',
    'landing.how.tag': 'How it works', 'landing.how.title': 'Four steps. Zero friction.',
    'landing.how.s1.t': 'Open the map', 'landing.how.s1.d': 'Click "Open the map" to enter the interactive FH6 carte.',
    'landing.how.s2.t': 'Drop a marker',
    'landing.how.s2.d': 'Create a spot (parking, viewpoint, 365, etc.) with a screenshot. You can then launch a live car meet directly from this spot — or place one freely anywhere on the map.',
    'landing.how.s3.t': 'Explore',
    'landing.how.s3.d': 'Like, comment, join a convoy, and cruise from spot to spot to discover the best places posted by the community.',
    'landing.how.s4.t': 'Launch a convoy',
    'landing.how.s4.d': "Create a convoy on the dedicated page and roll together in real time. Important: this site isn't linked to the game — invite your friends from inside Forza Horizon 6.",
    'landing.creator.title': 'Support the creator',
    'landing.creator.discord_join': 'Join the server',
    'landing.creator.subtitle': 'Find Ochibi on his other platforms.',
    'landing.cta.enter': 'Open the FH6 map',
    'landing.featured.year': 'Summer · 2026', 'landing.featured.cta': 'Open the map',
    'map.back_home': 'Home', 'map.search_placeholder': 'Search a spot...', 'map.filters': 'Filters',
    'map.cat.carmeet': 'Car Meets', 'map.cat.photo': 'Photo Spots', 'map.spots_count': 'Spots',
    'map.empty_logged_in': 'No spots. Be the first to add one!',
    'map.empty_logged_out': 'No spots. Sign in to add one.',
    'map.tip': 'Toggle "Add a spot" then click the map at the desired location.',
    'map.tip_strong': 'Add a spot', 'map.add_spot': 'Add a spot', 'map.cancel': 'Cancel',
    'map.click_to_place': 'Click the map to drop your spot',
    'map.legend.carmeet': 'Car Meet', 'map.legend.photo': 'Photo Spot',
    'map.online_now': 'online',
    'map.live_convoys': 'live convoys',
    'map.hide_sidebar': 'Hide filters',
    'map.show_sidebar': 'Show filters',
    'addspot.title': 'New spot', 'addspot.desc': 'Describe the location and choose its category. You can add a screenshot.',
    'addspot.cat.carmeet': 'Car Meet', 'addspot.cat.carmeet_sub': 'Meeting point',
    'addspot.cat.photo': 'Photo Spot', 'addspot.cat.photo_sub': 'Viewpoint / landscape',
    'addspot.field.title': 'Title', 'addspot.field.desc': 'Description (optional)',
    'addspot.upload.title': 'Screenshot (optional)', 'addspot.upload.cta': 'Drag or click to upload',
    'addspot.upload.hint': 'JPG · PNG · WEBP · 8MB max', 'addspot.submit': 'Publish spot',
    'addspot.created': 'Spot added!',
    'spot.by': 'by', 'spot.likes': 'likes', 'spot.like_singular': 'like',
    'spot.comments_count': 'comment', 'spot.comments_count_plural': 'comments',
    'spot.delete': 'Delete this spot', 'spot.moderate_admin': 'Moderate (admin)',
    'spot.deleted': 'Spot deleted', 'spot.confirm_delete': 'Delete this spot?',
    'spot.comments.title': 'Comments', 'spot.comments.placeholder': 'Leave a comment...',
    'spot.comments.placeholder_disabled': 'Sign in to comment', 'spot.comments.empty': 'Be the first to comment.',
    'spot.comment.reply': 'Reply', 'spot.comment.cancel': 'Cancel', 'spot.comment.like': 'Like',
    'spot.comment.reply_to': 'Reply to', 'spot.comment.deleted': 'Comment deleted',
    'spot.comment.confirm_delete': 'Delete this comment?',
    'convoys.title': 'Live convoys',
    'convoys.subtitle': 'Join an existing convoy or start your own. Share the link with friends so they can hop in.',
    'convoys.create': 'New convoy', 'convoys.empty': 'No convoys yet. Be the first!',
    'convoys.online': 'drivers online', 'convoys.online_others': 'more',
    'convoys.members': 'members', 'convoys.join': 'Join', 'convoys.joined': 'Joined',
    'convoys.leave': 'Leave', 'convoys.full': 'Full', 'convoys.share': 'Share', 'convoys.copied': 'Link copied!',
    'convoys.host': 'Host', 'convoys.season': 'Season', 'convoys.delete': 'Delete', 'convoys.deleted': 'Convoy deleted',
    'convoys.confirm_delete': 'Delete this convoy?', 'convoys.scheduled': 'Scheduled',
    'convoys.must_login_create': 'Sign in to create a convoy.', 'convoys.must_login_join': 'Sign in to join.',
    'convoys.launched': 'Convoy launched!', 'convoys.crew': 'Crew', 'convoys.discussion': 'Discussion',
    'convoys.chat.placeholder': 'Coordinate with drivers...', 'convoys.chat.placeholder_disabled': 'Sign in to chat',
    'convoys.chat.empty': 'No messages yet.',
    'convoys.form.name': 'Convoy name', 'convoys.form.desc': 'Description (goal, cars, skill level)',
    'convoys.form.max': 'Max capacity (host included)', 'convoys.form.submit': 'Launch convoy',
    'convoys.not_found': 'Convoy not found', 'convoys.joined_toast': 'Joined!', 'convoys.left_toast': 'Left',
    'convoys.request_sent': 'Request sent to host',
    'convoys.request_join': 'Request to join',
    'convoys.pending_approval': 'Pending approval',
    'convoys.cancel_request': 'Cancel my request',
    'convoys.request_cancelled': 'Request cancelled',
    'convoys.member_accepted': 'Player accepted into the convoy',
    'convoys.member_rejected': 'Request rejected',
    'convoys.pending_requests': 'Pending requests',
    'convoys.accept': 'Accept', 'convoys.reject': 'Reject',
    'notif.convoy_request': 'wants to join',
    'notif.convoy_requests_plural': 'requests for',
    'notif.manage': 'Manage',
    'notif.empty': 'No notifications',
    'notif.click_to_manage': 'Click to manage',
    'notif.click_to_view': 'Click to view profile',
    'notif.see': 'View',
    'notif.mark_all_read': 'Mark all as read',
    'notif.mark_all_read_short': 'Read all',
    'notif.clear_all': 'Clear all',
    'nav.notifications': 'Notifications',
    'map.hide_all': 'Hide all',
    'map.show_all': 'Show all',
    'landing.top_media.label': 'Trending',
    'landing.top_media.title': 'Hottest shots right now',
    'landing.top_media.subtitle': 'The top 3 most-loved posts by the community.',
    'landing.top_media.see_all': 'See all media',
    'landing.leaderboard.label': 'Top players',
    'landing.leaderboard.title': 'Community leaderboard',
    'landing.leaderboard.subtitle': 'Score = host × 15 + convoys × 5 + followers × 10 + online hours × 2',
    'landing.leaderboard.see_all': 'Full leaderboard',
    'public_profile.media.posts': 'Media posts',
    'public_profile.media.likes': 'Media likes',
    'public_profile.media.comments': 'Comments received',
    'public_profile.media.reactions': 'Reactions',
    'public_profile.publications': 'Publications',
    'profile.title': 'My profile', 'profile.member_of': 'Member of Horizon.Meet&Cruise',
    'profile.go_map': 'Add a spot',
    'profile.stats.spots': 'Spots created', 'profile.stats.meets': 'Car Meets',
    'profile.stats.photos': 'Photo Spots', 'profile.stats.likes': 'Likes received',
    'profile.my_spots': 'My spots',
    'profile.contributions_singular': 'contribution on the FH6 map.',
    'profile.contributions_plural': 'contributions on the FH6 map.',
    'profile.empty.title': 'No spots yet',
    'profile.empty.desc': 'Get started: open the map and drop your first car meet or photo spot.',
    'profile.empty.cta': 'Open the map', 'profile.unavailable': 'Profile unavailable.',
    'admin.title': 'Moderation', 'admin.logged_as': 'Logged in as',
    'admin.stats.users': 'Users', 'admin.stats.spots': 'Spots', 'admin.stats.carmeet': 'Car Meets',
    'admin.stats.photo': 'Photo Spots', 'admin.stats.comments': 'Comments',
    'admin.search': 'Filter by title, author, email...',
    'admin.tab.spots': 'Spots', 'admin.tab.comments': 'Comments', 'admin.tab.users': 'Users',
    'admin.confirm_delete_spot': 'Delete spot', 'admin.confirm_delete_comment': 'Delete this comment?',
    'admin.col.username': 'Username', 'admin.col.email': 'Email', 'admin.col.role': 'Role', 'admin.col.registered': 'Registered',
    'admin.reply_marker': 'reply',
        'landing.live.convoys': 'live convoys',
    'landing.live.online': 'drivers online',
    'landing.convoys.title': 'Live convoys',
    'landing.convoys.subtitle': 'Join a convoy starting now, or launch your own from the dedicated page.',
    'landing.convoys.cta': 'Browse all convoys',
    'landing.convoys.empty': 'No active convoys. Launch the first one!',
    'landing.convoys.create': 'New convoy',
        'gamertag.title': 'Your in-game tag',
    'gamertag.desc': 'Before you go on, enter your Forza Horizon 6 in-game tag so other drivers can spot you. You can change it later.',
    'gamertag.field': 'In-game tag (Forza Horizon 6)',
    'gamertag.hint': '40 chars max · used as your display name everywhere',
    'gamertag.save': 'Continue', 'gamertag.saved': 'Tag saved',
    'profile.avatar.change': 'Change photo',
    'profile.avatar.saved': 'Profile picture updated',
    'profile.socials.title': 'Linked accounts',
    'profile.socials.subtitle': 'Show your Discord, Twitch, YouTube and TikTok accounts on your profile.',
    'profile.socials.placeholder.discord': 'discord_user#0001 or tag',
    'profile.socials.placeholder.twitch': 'twitch.tv/your_handle',
    'profile.socials.placeholder.youtube': 'youtube.com/@your_channel',
    'profile.socials.placeholder.tiktok': '@your_tiktok',
    'profile.socials.saved': 'Accounts updated', 'profile.socials.save': 'Save',
    'profile.edit.gamer_tag': 'In-game tag', 'profile.edit.name': 'Display name',
    'profile.edit.save': 'Save', 'profile.edit.saved': 'Profile updated',
    'admin.edit_spot': 'Edit', 'admin.edit_spot.title': 'Edit spot',
    'admin.edit_spot.save': 'Save', 'admin.edit_spot.saved': 'Spot updated',
    'common.save': 'Save', 'common.cancel': 'Cancel', 'common.delete': 'Delete',
    'common.loading': 'Loading...', 'common.error': 'Error',
    'common.season.spring': 'Spring', 'common.season.summer': 'Summer',
    'common.season.autumn': 'Autumn', 'common.season.winter': 'Winter',
    'lang.label': 'Language',
  },
  de: {
    'nav.home': 'Startseite', 'nav.map': 'FH6-Karte', 'nav.convoys': 'Konvois',
    'nav.messages': 'Nachrichten',
    'messages.title': 'Nachrichten',
    'messages.tab.dms': 'Chats',
    'messages.tab.friends': 'Freunde',
    'messages.empty_threads': 'Keine Chats. Füge einen Freund hinzu.',
    'messages.empty_conv': 'Sende die erste Nachricht.',
    'messages.select_conv': 'Wähle einen Chat oder Freund.',
    'messages.placeholder': 'Deine Nachricht...',
    'messages.search_user': 'Fahrer suchen...',
    'messages.pending_in': 'Eingehende Anfragen',
    'messages.friends_count': 'Freunde',
    'messages.no_friends': 'Noch keine Freunde.',
    'messages.request_sent': 'Freundschaftsanfrage gesendet',
    'friend.add': 'Hinzufügen',
    'friend.pending': 'Ausstehend',
    'friend.respond': 'Antworten',
    'friend.message': 'Nachricht',
    'notif.friend_request': 'hat dir eine Freundschaftsanfrage gesendet',
    'chat.title': 'Nachrichten',
    'chat.open': 'Chat öffnen',
    'chat.full_view': 'Alles ansehen', 'nav.about': 'Über',
    'chat.friends_convoys': 'Freunde & Konvois',
    'chat.my_convoy': 'Mein Konvoi',
    'chat.pilots': 'Piloten',
    'chat.open_short': 'Öffnen',
    'chat.friend_requests': 'Freundschaftsanfragen',
    'chat.friends': 'Freunde',
    'chat.no_friends': 'Noch keine Freunde.',
    'chat.following': 'Verfolgt',
    'chat.unread_messages': 'Ungelesene Nachrichten',
    'chat.quick.messages': 'Nachrichten',
    'chat.quick.messages_sub': 'Private Nachrichten',
    'chat.quick.convoy': 'Konvoi-Chat',
    'chat.quick.convoy_none': 'Kein aktiver Konvoi',
    'welcome.title': 'Willkommen bei Horizon.Meet&Cruise',
    'welcome.subtitle': 'Tritt der Community bei, um Spots zu markieren, Car-Meets zu starten und im Konvoi mit anderen FH6-Fahrern zu cruisen.',
    'welcome.register': 'Konto erstellen',
    'welcome.login': 'Ich habe bereits ein Konto',
    'welcome.later': 'Später',
    'composer.add_image': 'Bild hinzufügen', 'composer.image_only': 'Nur Bilder', 'composer.too_large': 'Datei zu groß (8MB max)',
    'public_profile.spots_of': 'Spots von', 'public_profile.no_spots': 'Noch keine Spots.',
    'convoys.host.manage': 'Verwalten', 'convoys.host.kick_member': 'Aus dem Konvoi werfen',
    'convoys.host.transfer_to': 'Host übertragen an', 'convoys.host.kick_confirm_title': 'Diesen Fahrer rauswerfen?',
    'convoys.host.kick_confirm_body': 'Rauswurf bestätigen von', 'convoys.host.transfer_confirm_title': 'Host-Rolle übertragen?',
    'convoys.host.transfer_confirm_body': 'Die Rolle übertragen an', 'convoys.host.kicked': 'Fahrer rausgeworfen',
    'convoys.host.transferred': 'Host übertragen', 'convoys.host.banned': 'Gebannt',
    'convoys.host.unban': 'Wieder zulassen', 'convoys.host.unbanned': 'Fahrer wieder zugelassen',
    'map.fullscreen': 'Vollbild', 'map.exit_fullscreen': 'Vollbild beenden',
    'map.signal_carmeet': 'Car Meet melden', 'map.live': 'live',
    'map.cat.live_carmeet': 'Car Meet (live)', 'map.cat.viewpoint': 'Aussichtspunkt',
    'map.cat.parking': 'Parkplatz', 'map.cat.gas': 'Tankstelle', 'map.cat.spot': 'Spot',
    'map.cat.s365': '365',
    'addspot.cat.viewpoint': 'Aussichtspunkt', 'addspot.cat.viewpoint_sub': 'Panoramablick',
    'addspot.cat.parking': 'Parkplatz', 'addspot.cat.parking_sub': 'Parkmöglichkeit',
    'addspot.cat.gas': 'Tankstelle', 'addspot.cat.gas_sub': 'Tanken / Pause',
    'addspot.cat.spot': 'Spot', 'addspot.cat.spot_sub': 'Cooler Ort',
    'addspot.cat.s365': '365', 'addspot.cat.s365_sub': '24/7-Shop',
    'spot.start_livemeet': 'Live-Car-Meet hier starten',
    'spot.live_here': 'Live-Car-Meets hier',
    'livemeet.locked_on_spot': 'Position des ausgewählten Spots',
    'livemeet.joined_convoy': 'Konvoi-Anfrage gesendet',
    'livemeet.convoy_full': 'Konvoi voll',
    'livemeet.join_convoy': 'Beitritt anfragen',
    'livemeet.stop_btn': 'Live-Car-Meet beenden',
    'livemeet.confirm_stop': 'Dieses Live-Car-Meet beenden? Der Konvoi bleibt aktiv.',
    'livemeet.stopped': 'Live-Car-Meet beendet',
    'convoys.chat.members_only': 'Nur für Mitglieder',
    'common.error': 'Ein Fehler ist aufgetreten',
    'map.by': 'von',
    'addspot.placeholder.title': 'Sonnenuntergangsklippe', 'addspot.placeholder.desc': 'Goldene Stunde, leichter Zugang, Parkplatz für 5 Autos...',
    'admin.edit_spot.image': 'Screenshot', 'admin.edit_spot.upload_cta': 'Screenshot ersetzen',
    'nav.leaderboard': 'Rangliste',
    'nav.media': 'Medien',
    'media.label': 'Medien-Bereich', 'media.title': 'Teile deine besten Aufnahmen',
    'media.subtitle': 'Fotos, Videos, YouTube/Twitch-Clips. Liken, kommentieren, reagieren.',
    'media.tab.posts': 'Beiträge', 'media.tab.from_spots': 'Aus den Spots',
    'media.new_post': 'Neuer Beitrag', 'media.publish': 'Veröffentlichen',
    'media.empty': 'Noch keine Beiträge.', 'media.confirm_delete': 'Diesen Beitrag löschen?',
    'leaderboard.title': 'Rangliste', 'leaderboard.subtitle': 'Top-Fahrer der Horizon.Meet&Cruise Community.',
    'leaderboard.formula': 'Formel', 'leaderboard.spots': 'Spots', 'leaderboard.hosted': 'Hosts',
    'leaderboard.joined': 'Konvois', 'leaderboard.likes': 'Likes', 'leaderboard.score': 'Punkte',
    'leaderboard.driver': 'Fahrer', 'leaderboard.empty': 'Noch keine eingestuften Fahrer.',
    'leaderboard.followers': 'Follower', 'leaderboard.sort_by': 'Sortieren nach',
    'follow.follow': 'Folgen', 'follow.following': 'Folgst',
    'follow.followed': 'Folgst du jetzt', 'follow.unfollowed': 'Entfolgt',
    'livemeet.title': 'Live Car Meet', 'livemeet.desc': 'Sage anderen Fahrern, dass du gerade ein Car Meet veranstaltest.',
    'livemeet.field.title': 'Meet-Titel', 'livemeet.placeholder': 'Late night drift @ Tokyo',
    'livemeet.coords_set': 'Position bereit', 'livemeet.pick_on_map': 'Klicke auf die Karte, um den Punkt zu wählen',
    'livemeet.pick_first': 'Wähle zuerst einen Punkt auf der Karte.', 'livemeet.pick_banner': 'Klicke auf die Karte für dein Car Meet',
    'livemeet.ttl_hint': 'Sichtbar 4h oder bis du es beendest.',
    'livemeet.broadcast': 'Meet senden', 'livemeet.created': 'Car Meet ausgestrahlt!',
    'livemeet.default_title': 'Car Meet läuft',
    'livemeet.expires_at': 'Endet um', 'livemeet.stop': 'Mein Car Meet beenden',
    'livemeet.stop_confirm': 'Live-Car-Meet beenden?', 'livemeet.stopped': 'Car Meet beendet',
    'livemeet.admin_delete': 'Löschen (Admin)', 'livemeet.deleted': 'Car Meet gelöscht',
    'livemeet.field.convoy': 'Konvoi verknüpfen', 'livemeet.no_convoy': 'Kein verknüpfter Konvoi',
    'livemeet.convoy_hint': 'Fahrer können deinem Konvoi direkt von der Karte aus beitreten.',
    'livemeet.linked_convoy': 'Verknüpfter Konvoi', 'livemeet.join_convoy': 'Konvoi beitreten',
    'livemeet.joined_convoy': 'Konvoi beigetreten!', 'livemeet.convoy_full': 'Konvoi voll',
    'convoys.members': 'Mitglieder',
    'common.confirm': 'Bestätigen', 'common.cancel': 'Abbrechen',
    'nav.login': 'Anmelden', 'nav.logout': 'Abmelden', 'nav.profile': 'Mein Profil', 'nav.admin': 'Moderation',
    'auth.title.login': 'Anmelden', 'auth.title.register': 'Konto erstellen',
    'auth.desc': 'Tritt der FH6-Community bei. Markiere Spots, liken und kommentieren.',
    'auth.tab.login': 'Anmelden', 'auth.tab.register': 'Registrieren',
    'auth.name': 'Benutzername', 'auth.email': 'E-Mail', 'auth.password': 'Passwort',
    'auth.submit.login': 'Anmelden', 'auth.submit.register': 'Registrieren',
    'auth.discord': 'Mit Discord fortfahren', 'auth.or': 'oder',
    'auth.welcome_back': 'Willkommen!', 'auth.account_created': 'Konto erstellt.',
    'auth.must_login': 'Melde dich an, um fortzufahren.',
    'hero.tag': 'Community · Spots · Konvois · Fotos',
    'hero.title.line1': 'Die Karte von', 'hero.title.line2': 'von dir markiert.',
    'hero.subtitle': 'Markiere die besten Spots auf der FH6-Karte, teile sie mit der Community und starte deine eigenen Live-Car-Meets & Konvois zum gemeinsamen Fahren.',
    'hero.cta.map': 'Karte öffnen', 'hero.cta.convoys': 'Konvois ansehen', 'hero.cta.about': 'So funktioniert es',
    'hero.stats.map': '4K-Karte', 'hero.stats.map_sub': 'Satellit',
    'hero.stats.photos': 'Fotospots', 'hero.stats.photos_sub': 'geteilt',
    'hero.stats.meets': 'Car-Meets', 'hero.stats.meets_sub': 'Community',
    'hero.stats.likes': 'Likes & Bewertungen', 'hero.stats.likes_sub': 'Statistik',
    'landing.terrains.title1': 'Ein Spielfeld,', 'landing.terrains.title2': 'drei Welten.',
    'landing.terrains.subtitle': 'Von schneebedeckten Gipfeln bis Industriehäfen — markiere jeden Ort.',
    'landing.terrains.mountains.t': 'Schneebedeckte Gipfel', 'landing.terrains.mountains.d': 'Bergpässe, Schnee-Drifts, spektakuläre Panoramen.',
    'landing.terrains.forests.t': 'Wälder & Täler', 'landing.terrains.forests.d': 'Kurvige Straßen, Hängebrücken, Flüsse.',
    'landing.terrains.city.t': 'Stadt & Hafen', 'landing.terrains.city.d': 'Neon-Tunnel, Stadtautobahnen, Docks.',
    'landing.how.tag': 'So funktioniert es', 'landing.how.title': 'Vier Schritte. Null Reibung.',
    'landing.how.s1.t': 'Öffne die Karte', 'landing.how.s1.d': 'Klicke "Karte öffnen", um die interaktive FH6-Karte zu öffnen.',
    'landing.how.s2.t': 'Setze einen Marker', 'landing.how.s2.d': 'Erstelle einen Spot (Parkplatz, Aussichtspunkt, 365 usw.) mit Screenshot. Starte dann ein Live-Car-Meet direkt vom Spot — oder setze frei eines an einer beliebigen Stelle der Karte.',
    'landing.how.s3.t': 'Erkunden', 'landing.how.s3.d': 'Liken, kommentieren, Konvoi beitreten und von Spot zu Spot fahren, um die besten Orte der Community zu entdecken.',
    'landing.how.s4.t': 'Starte einen Konvoi',
    'landing.how.s4.d': 'Erstelle einen Konvoi auf der dedizierten Seite und fahrt zusammen in Echtzeit. Wichtig: Diese Seite ist nicht mit dem Spiel verbunden — lade deine Freunde direkt aus Forza Horizon 6 ein.',
    'landing.creator.title': 'Unterstütze den Creator',
    'landing.creator.discord_join': 'Server beitreten',
    'landing.creator.subtitle': 'Finde Ochibi auf seinen anderen Plattformen.',
    'landing.cta.enter': 'FH6-Karte öffnen',
    'landing.featured.year': 'Summer · 2026', 'landing.featured.cta': 'Karte öffnen',
    'map.back_home': 'Startseite', 'map.search_placeholder': 'Spot suchen...', 'map.filters': 'Filter',
    'map.cat.carmeet': 'Car-Meets', 'map.cat.photo': 'Fotospots', 'map.spots_count': 'Spots',
    'map.empty_logged_in': 'Keine Spots. Sei der Erste!', 'map.empty_logged_out': 'Keine Spots. Melde dich an.',
    'map.tip': 'Aktiviere "Spot hinzufügen" und klicke auf die Karte.',
    'map.tip_strong': 'Spot hinzufügen', 'map.add_spot': 'Spot hinzufügen', 'map.cancel': 'Abbrechen',
    'map.click_to_place': 'Klicke auf die Karte, um deinen Spot zu setzen',
    'map.legend.carmeet': 'Car Meet', 'map.legend.photo': 'Fotospot',
    'map.online_now': 'online',
    'map.live_convoys': 'Konvois aktiv',
    'map.hide_sidebar': 'Filter ausblenden',
    'map.show_sidebar': 'Filter anzeigen',
    'addspot.title': 'Neuer Spot', 'addspot.desc': 'Beschreibe den Ort und wähle die Kategorie.',
    'addspot.cat.carmeet': 'Car Meet', 'addspot.cat.carmeet_sub': 'Treffpunkt',
    'addspot.cat.photo': 'Fotospot', 'addspot.cat.photo_sub': 'Aussichtspunkt',
    'addspot.field.title': 'Titel', 'addspot.field.desc': 'Beschreibung (optional)',
    'addspot.upload.title': 'Screenshot (optional)', 'addspot.upload.cta': 'Ziehen oder klicken zum Hochladen',
    'addspot.upload.hint': 'JPG · PNG · WEBP · max 8 MB', 'addspot.submit': 'Spot veröffentlichen',
    'addspot.created': 'Spot hinzugefügt!',
    'spot.by': 'von', 'spot.likes': 'Likes', 'spot.like_singular': 'Like',
    'spot.comments_count': 'Kommentar', 'spot.comments_count_plural': 'Kommentare',
    'spot.delete': 'Spot löschen', 'spot.moderate_admin': 'Moderieren (Admin)',
    'spot.deleted': 'Spot gelöscht', 'spot.confirm_delete': 'Diesen Spot löschen?',
    'spot.comments.title': 'Kommentare', 'spot.comments.placeholder': 'Kommentar verfassen...',
    'spot.comments.placeholder_disabled': 'Melde dich zum Kommentieren an', 'spot.comments.empty': 'Sei der Erste!',
    'spot.comment.reply': 'Antworten', 'spot.comment.cancel': 'Abbrechen', 'spot.comment.like': 'Gefällt mir',
    'spot.comment.reply_to': 'Antworten an', 'spot.comment.deleted': 'Kommentar gelöscht',
    'spot.comment.confirm_delete': 'Kommentar löschen?',
    'convoys.title': 'Aktive Konvois',
    'convoys.subtitle': 'Tritt einem Konvoi bei oder starte deinen eigenen.',
    'convoys.create': 'Neuer Konvoi', 'convoys.empty': 'Noch keine Konvois. Sei der Erste!',
    'convoys.online': 'Fahrer online', 'convoys.online_others': 'weitere',
    'convoys.members': 'Mitglieder', 'convoys.join': 'Beitreten', 'convoys.joined': 'Beigetreten',
    'convoys.leave': 'Verlassen', 'convoys.full': 'Voll', 'convoys.share': 'Teilen', 'convoys.copied': 'Link kopiert!',
    'convoys.host': 'Host', 'convoys.season': 'Jahreszeit', 'convoys.delete': 'Löschen', 'convoys.deleted': 'Konvoi gelöscht',
    'convoys.confirm_delete': 'Konvoi löschen?', 'convoys.scheduled': 'Geplant',
    'convoys.must_login_create': 'Melde dich an, um einen Konvoi zu erstellen.',
    'convoys.must_login_join': 'Melde dich an, um beizutreten.',
    'convoys.launched': 'Konvoi gestartet!', 'convoys.crew': 'Crew', 'convoys.discussion': 'Diskussion',
    'convoys.chat.placeholder': 'Koordiniere dich mit den Fahrern...', 'convoys.chat.placeholder_disabled': 'Melde dich an',
    'convoys.chat.empty': 'Keine Nachrichten.',
    'convoys.form.name': 'Konvoi-Name', 'convoys.form.desc': 'Beschreibung (Ziel, Autos, Niveau)',
    'convoys.form.max': 'Max. Kapazität (inkl. Host)', 'convoys.form.submit': 'Konvoi starten',
    'convoys.not_found': 'Konvoi nicht gefunden', 'convoys.joined_toast': 'Beigetreten!', 'convoys.left_toast': 'Verlassen',
    'profile.title': 'Mein Profil', 'profile.member_of': 'Mitglied von Horizon.Meet&Cruise',
    'profile.go_map': 'Spot hinzufügen',
    'profile.stats.spots': 'Erstellte Spots', 'profile.stats.meets': 'Car-Meets',
    'profile.stats.photos': 'Fotospots', 'profile.stats.likes': 'Erhaltene Likes',
    'profile.my_spots': 'Meine Spots',
    'profile.contributions_singular': 'Beitrag zur FH6-Karte.',
    'profile.contributions_plural': 'Beiträge zur FH6-Karte.',
    'profile.empty.title': 'Noch keine Spots', 'profile.empty.desc': 'Öffne die Karte und setze deinen ersten Spot.',
    'profile.empty.cta': 'Karte öffnen', 'profile.unavailable': 'Profil nicht verfügbar.',
    'admin.title': 'Moderation', 'admin.logged_as': 'Angemeldet als',
    'admin.stats.users': 'Benutzer', 'admin.stats.spots': 'Spots', 'admin.stats.carmeet': 'Car-Meets',
    'admin.stats.photo': 'Fotospots', 'admin.stats.comments': 'Kommentare',
    'admin.search': 'Nach Titel, Autor, E-Mail filtern...',
    'admin.tab.spots': 'Spots', 'admin.tab.comments': 'Kommentare', 'admin.tab.users': 'Benutzer',
    'admin.confirm_delete_spot': 'Spot löschen', 'admin.confirm_delete_comment': 'Kommentar löschen?',
    'admin.col.username': 'Benutzername', 'admin.col.email': 'E-Mail', 'admin.col.role': 'Rolle', 'admin.col.registered': 'Registriert',
    'admin.reply_marker': 'Antwort',
        'landing.live.convoys': 'aktive Konvois',
    'landing.live.online': 'Fahrer online',
    'landing.convoys.title': 'Live-Konvois',
    'landing.convoys.subtitle': 'Tritt einem laufenden Konvoi bei oder starte deinen eigenen.',
    'landing.convoys.cta': 'Alle Konvois ansehen',
    'landing.convoys.empty': 'Keine aktiven Konvois. Sei der Erste!',
    'landing.convoys.create': 'Neuer Konvoi',
        'gamertag.title': 'Dein In-Game-Tag',
    'gamertag.desc': 'Gib deinen Forza Horizon 6 In-Game-Tag ein, damit andere Fahrer dich finden. Änderbar.',
    'gamertag.field': 'In-Game-Tag (Forza Horizon 6)',
    'gamertag.hint': '40 Zeichen max · überall als Anzeigename', 'gamertag.save': 'Weiter', 'gamertag.saved': 'Tag gespeichert',
    'profile.avatar.change': 'Foto ändern',
    'profile.avatar.saved': 'Profilbild aktualisiert',
    'profile.socials.title': 'Verknüpfte Konten',
    'profile.socials.subtitle': 'Zeige deine Discord-, Twitch-, YouTube- und TikTok-Konten auf deinem Profil.',
    'profile.socials.placeholder.discord': 'discord_user#0001',
    'profile.socials.placeholder.twitch': 'twitch.tv/dein_handle',
    'profile.socials.placeholder.youtube': 'youtube.com/@dein_kanal',
    'profile.socials.placeholder.tiktok': '@dein_tiktok',
    'profile.socials.saved': 'Konten aktualisiert', 'profile.socials.save': 'Speichern',
    'profile.edit.gamer_tag': 'In-Game-Tag', 'profile.edit.name': 'Anzeigename',
    'profile.edit.save': 'Speichern', 'profile.edit.saved': 'Profil aktualisiert',
    'admin.edit_spot': 'Bearbeiten', 'admin.edit_spot.title': 'Spot bearbeiten',
    'admin.edit_spot.save': 'Speichern', 'admin.edit_spot.saved': 'Spot aktualisiert',
    'common.save': 'Speichern', 'common.cancel': 'Abbrechen', 'common.delete': 'Löschen',
    'common.loading': 'Lädt...', 'common.error': 'Fehler',
    'common.season.spring': 'Frühling', 'common.season.summer': 'Sommer',
    'common.season.autumn': 'Herbst', 'common.season.winter': 'Winter',
    'lang.label': 'Sprache',
  },
  es: {
    'nav.home': 'Inicio', 'nav.map': 'Mapa FH6', 'nav.convoys': 'Convoyes',
    'nav.messages': 'Mensajes',
    'messages.title': 'Mensajes',
    'messages.tab.dms': 'Chats',
    'messages.tab.friends': 'Amigos',
    'messages.empty_threads': 'Sin chats. Añade un amigo para empezar.',
    'messages.empty_conv': 'Envía el primer mensaje.',
    'messages.select_conv': 'Elige un chat o un amigo.',
    'messages.placeholder': 'Tu mensaje...',
    'messages.search_user': 'Buscar piloto...',
    'messages.pending_in': 'Solicitudes recibidas',
    'messages.friends_count': 'Amigos',
    'messages.no_friends': 'Aún no hay amigos.',
    'messages.request_sent': 'Solicitud enviada',
    'friend.add': 'Añadir',
    'friend.pending': 'Pendiente',
    'friend.respond': 'Responder',
    'friend.message': 'Mensaje',
    'notif.friend_request': 'te envió una solicitud de amistad',
    'chat.title': 'Mensajes',
    'chat.open': 'Abrir chat',
    'chat.full_view': 'Ver todo', 'nav.about': 'Acerca',
    'chat.friends_convoys': 'Amigos y convoyes',
    'chat.my_convoy': 'Mi convoy',
    'chat.pilots': 'pilotos',
    'chat.open_short': 'Abrir',
    'chat.friend_requests': 'Solicitudes de amistad',
    'chat.friends': 'Amigos',
    'chat.no_friends': 'Aún no tienes amigos.',
    'chat.following': 'Seguidos',
    'chat.unread_messages': 'Mensajes sin leer',
    'chat.quick.messages': 'Mensajes',
    'chat.quick.messages_sub': 'Mensajes privados',
    'chat.quick.convoy': 'Chat del convoy',
    'chat.quick.convoy_none': 'Sin convoy activo',
    'welcome.title': 'Bienvenido a Horizon.Meet&Cruise',
    'welcome.subtitle': 'Únete a la comunidad para marcar tus spots, lanzar car meets y rodar en convoy con otros pilotos de FH6.',
    'welcome.register': 'Crear una cuenta',
    'welcome.login': 'Ya tengo una cuenta',
    'welcome.later': 'Más tarde',
    'composer.add_image': 'Añadir imagen', 'composer.image_only': 'Solo imágenes', 'composer.too_large': 'Archivo demasiado grande (8MB máx)',
    'public_profile.spots_of': 'Spots de', 'public_profile.no_spots': 'Sin spots aún.',
    'convoys.host.manage': 'Gestionar', 'convoys.host.kick_member': 'Expulsar del convoy',
    'convoys.host.transfer_to': 'Transferir anfitrión a', 'convoys.host.kick_confirm_title': '¿Expulsar a este piloto?',
    'convoys.host.kick_confirm_body': 'Confirmar expulsión de', 'convoys.host.transfer_confirm_title': '¿Transferir rol de anfitrión?',
    'convoys.host.transfer_confirm_body': 'Transferir el rol a', 'convoys.host.kicked': 'Piloto expulsado',
    'convoys.host.transferred': 'Anfitrión transferido', 'convoys.host.banned': 'Baneados',
    'convoys.host.unban': 'Reintegrar', 'convoys.host.unbanned': 'Piloto reintegrado',
    'map.fullscreen': 'Pantalla completa', 'map.exit_fullscreen': 'Salir de pantalla completa',
    'map.signal_carmeet': 'Señalar Car Meet', 'map.live': 'live',
    'map.cat.live_carmeet': 'Car Meet (live)', 'map.cat.viewpoint': 'Mirador',
    'map.cat.parking': 'Aparcamiento', 'map.cat.gas': 'Gasolinera', 'map.cat.spot': 'Spot',
    'map.cat.s365': '365',
    'addspot.cat.viewpoint': 'Mirador', 'addspot.cat.viewpoint_sub': 'Vista panorámica',
    'addspot.cat.parking': 'Aparcamiento', 'addspot.cat.parking_sub': 'Lugar para aparcar',
    'addspot.cat.gas': 'Gasolinera', 'addspot.cat.gas_sub': 'Repostar / descanso',
    'addspot.cat.spot': 'Spot', 'addspot.cat.spot_sub': 'Lugar interesante',
    'addspot.cat.s365': '365', 'addspot.cat.s365_sub': 'Tienda 24/7',
    'spot.start_livemeet': 'Iniciar un car meet en vivo aquí',
    'spot.live_here': 'Car meets en vivo aquí',
    'livemeet.locked_on_spot': 'Posición del spot seleccionado',
    'livemeet.joined_convoy': 'Solicitud de convoy enviada',
    'livemeet.convoy_full': 'Convoy lleno',
    'livemeet.join_convoy': 'Solicitar unirse',
    'livemeet.stop_btn': 'Detener el car meet en vivo',
    'livemeet.confirm_stop': '¿Detener este car meet en vivo? El convoy permanecerá activo.',
    'livemeet.stopped': 'Car meet en vivo detenido',
    'convoys.chat.members_only': 'Solo miembros',
    'common.error': 'Se ha producido un error',
    'map.by': 'por',
    'addspot.placeholder.title': 'Acantilado del atardecer', 'addspot.placeholder.desc': 'Hora dorada, fácil acceso, aparcamiento para 5 coches...',
    'admin.edit_spot.image': 'Captura', 'admin.edit_spot.upload_cta': 'Reemplazar captura',
    'nav.leaderboard': 'Clasificación',
    'nav.media': 'Medios',
    'media.label': 'Espacio Multimedia', 'media.title': 'Comparte tus mejores capturas',
    'media.subtitle': 'Fotos, vídeos, clips de YouTube/Twitch. Da likes, comenta, reacciona.',
    'media.tab.posts': 'Publicaciones', 'media.tab.from_spots': 'Desde spots',
    'media.new_post': 'Nueva publicación', 'media.publish': 'Publicar',
    'media.empty': 'Aún no hay publicaciones.', 'media.confirm_delete': '¿Eliminar esta publicación?',
    'leaderboard.title': 'Clasificación', 'leaderboard.subtitle': 'Los mejores pilotos de Horizon.Meet&Cruise.',
    'leaderboard.formula': 'Fórmula', 'leaderboard.spots': 'Spots', 'leaderboard.hosted': 'Anfitrión',
    'leaderboard.joined': 'Convoys', 'leaderboard.likes': 'Likes', 'leaderboard.score': 'Puntos',
    'leaderboard.driver': 'Piloto', 'leaderboard.empty': 'Aún no hay pilotos clasificados.',
    'leaderboard.followers': 'Seguidores', 'leaderboard.sort_by': 'Ordenar por',
    'follow.follow': 'Seguir', 'follow.following': 'Siguiendo',
    'follow.followed': 'Ahora sigues', 'follow.unfollowed': 'Dejaste de seguir',
    'livemeet.title': 'Car Meet en vivo', 'livemeet.desc': 'Avisa a otros pilotos que organizas un car meet ahora mismo.',
    'livemeet.field.title': 'Título del meet', 'livemeet.placeholder': 'Late night drift @ Tokyo',
    'livemeet.coords_set': 'Posición lista', 'livemeet.pick_on_map': 'Haz clic en el mapa para elegir el punto',
    'livemeet.pick_first': 'Primero elige un punto en el mapa.', 'livemeet.pick_banner': 'Haz clic en el mapa para colocar tu car meet',
    'livemeet.ttl_hint': 'Visible 4h o hasta que lo detengas.',
    'livemeet.broadcast': 'Transmitir meet', 'livemeet.created': '¡Car meet transmitido!',
    'livemeet.default_title': 'Car meet en curso',
    'livemeet.expires_at': 'Termina a las', 'livemeet.stop': 'Detener mi car meet',
    'livemeet.stop_confirm': '¿Detener tu car meet en vivo?', 'livemeet.stopped': 'Car meet detenido',
    'livemeet.admin_delete': 'Eliminar (admin)', 'livemeet.deleted': 'Car meet eliminado',
    'livemeet.field.convoy': 'Vincular un convoy', 'livemeet.no_convoy': 'Sin convoy vinculado',
    'livemeet.convoy_hint': 'Los pilotos podrán unirse a tu convoy directamente desde el mapa.',
    'livemeet.linked_convoy': 'Convoy vinculado', 'livemeet.join_convoy': 'Unirse al convoy',
    'livemeet.joined_convoy': '¡Convoy unido!', 'livemeet.convoy_full': 'Convoy lleno',
    'convoys.members': 'miembros',
    'common.confirm': 'Confirmar', 'common.cancel': 'Cancelar',
    'nav.login': 'Iniciar sesión', 'nav.logout': 'Cerrar sesión', 'nav.profile': 'Mi perfil', 'nav.admin': 'Moderación',
    'auth.title.login': 'Iniciar sesión', 'auth.title.register': 'Crear cuenta',
    'auth.desc': 'Únete a la comunidad FH6. Coloca spots, dale like y comenta.',
    'auth.tab.login': 'Iniciar', 'auth.tab.register': 'Registrarse',
    'auth.name': 'Apodo', 'auth.email': 'Email', 'auth.password': 'Contraseña',
    'auth.submit.login': 'Iniciar sesión', 'auth.submit.register': 'Registrarse',
    'auth.discord': 'Continuar con Discord', 'auth.or': 'o',
    'auth.welcome_back': '¡Bienvenido!', 'auth.account_created': 'Cuenta creada.',
    'auth.must_login': 'Inicia sesión para continuar.',
    'hero.tag': 'Comunidad · Spots · Convoyes · Fotos',
    'hero.title.line1': 'El mapa de', 'hero.title.line2': 'marcado por ti.',
    'hero.subtitle': 'Marca los mejores spots del mapa de FH6, compártelos con la comunidad y lanza tus propios car meets y convoyes en vivo para conducir juntos.',
    'hero.cta.map': 'Abrir el mapa', 'hero.cta.convoys': 'Ver convoyes', 'hero.cta.about': 'Cómo funciona',
    'hero.stats.map': 'Mapa 4K', 'hero.stats.map_sub': 'satélite',
    'hero.stats.photos': 'Spots de foto', 'hero.stats.photos_sub': 'compartidos',
    'hero.stats.meets': 'Car meets', 'hero.stats.meets_sub': 'comunidad',
    'hero.stats.likes': 'Likes & opiniones', 'hero.stats.likes_sub': 'Estadística',
    'landing.terrains.title1': 'Un terreno de juego,', 'landing.terrains.title2': 'tres universos.',
    'landing.terrains.subtitle': 'Desde picos nevados hasta puertos industriales. Cada rincón tiene su spot.',
    'landing.terrains.mountains.t': 'Picos nevados', 'landing.terrains.mountains.d': 'Puertos de montaña, drift en nieve.',
    'landing.terrains.forests.t': 'Bosques & valles', 'landing.terrains.forests.d': 'Carreteras sinuosas entre pinos.',
    'landing.terrains.city.t': 'Metrópolis & puerto', 'landing.terrains.city.d': 'Túneles de neón, autopistas urbanas.',
    'landing.how.tag': 'Cómo funciona', 'landing.how.title': 'Cuatro pasos. Cero fricción.',
    'landing.how.s1.t': 'Abre el mapa', 'landing.how.s1.d': 'Haz clic en "Abrir el mapa".',
    'landing.how.s2.t': 'Coloca un marcador', 'landing.how.s2.d': 'Crea un spot (aparcamiento, mirador, 365, etc.) con captura. Luego puedes iniciar un car meet en vivo desde ese spot — o colocar uno libremente en cualquier punto del mapa.',
    'landing.how.s3.t': 'Explora', 'landing.how.s3.d': 'Da like, comenta, únete a un convoy y pasea de spot en spot para descubrir los mejores lugares publicados por la comunidad.',
    'landing.how.s4.t': 'Lanza un convoy',
    'landing.how.s4.d': 'Crea un convoy en la página dedicada y rodad juntos en tiempo real. Importante: este sitio no está vinculado con el juego — invita a tus amigos desde dentro de Forza Horizon 6.',
    'landing.creator.title': 'Apoya al creador',
    'landing.creator.discord_join': 'Unirse al servidor',
    'landing.creator.subtitle': 'Encuentra a Ochibi en sus otras plataformas.',
    'landing.cta.enter': 'Abrir el mapa de FH6',
    'landing.featured.year': 'Summer · 2026', 'landing.featured.cta': 'Abrir el mapa',
    'map.back_home': 'Inicio', 'map.search_placeholder': 'Buscar un spot...', 'map.filters': 'Filtros',
    'map.cat.carmeet': 'Car Meets', 'map.cat.photo': 'Spots de foto', 'map.spots_count': 'Spots',
    'map.empty_logged_in': '¡Ningún spot. Sé el primero!', 'map.empty_logged_out': 'Ningún spot. Inicia sesión.',
    'map.tip': 'Activa "Añadir un spot" y haz clic en el mapa.',
    'map.tip_strong': 'Añadir un spot', 'map.add_spot': 'Añadir un spot', 'map.cancel': 'Cancelar',
    'map.click_to_place': 'Haz clic en el mapa para colocar tu spot',
    'map.legend.carmeet': 'Car Meet', 'map.legend.photo': 'Spot foto',
    'map.online_now': 'en línea',
    'map.live_convoys': 'convoyes activos',
    'map.hide_sidebar': 'Ocultar filtros',
    'map.show_sidebar': 'Mostrar filtros',
    'addspot.title': 'Nuevo spot', 'addspot.desc': 'Describe el lugar y elige la categoría.',
    'addspot.cat.carmeet': 'Car Meet', 'addspot.cat.carmeet_sub': 'Punto de encuentro',
    'addspot.cat.photo': 'Spot foto', 'addspot.cat.photo_sub': 'Mirador / paisaje',
    'addspot.field.title': 'Título', 'addspot.field.desc': 'Descripción (opcional)',
    'addspot.upload.title': 'Captura (opcional)', 'addspot.upload.cta': 'Arrastra o haz clic',
    'addspot.upload.hint': 'JPG · PNG · WEBP · 8MB máx', 'addspot.submit': 'Publicar el spot',
    'addspot.created': '¡Spot añadido!',
    'spot.by': 'por', 'spot.likes': 'likes', 'spot.like_singular': 'like',
    'spot.comments_count': 'comentario', 'spot.comments_count_plural': 'comentarios',
    'spot.delete': 'Eliminar este spot', 'spot.moderate_admin': 'Moderar (admin)',
    'spot.deleted': 'Spot eliminado', 'spot.confirm_delete': '¿Eliminar este spot?',
    'spot.comments.title': 'Comentarios', 'spot.comments.placeholder': 'Deja un comentario...',
    'spot.comments.placeholder_disabled': 'Inicia sesión para comentar', 'spot.comments.empty': '¡Sé el primero!',
    'spot.comment.reply': 'Responder', 'spot.comment.cancel': 'Cancelar', 'spot.comment.like': 'Me gusta',
    'spot.comment.reply_to': 'Responder a', 'spot.comment.deleted': 'Comentario eliminado',
    'spot.comment.confirm_delete': '¿Eliminar este comentario?',
    'convoys.title': 'Convoyes activos',
    'convoys.subtitle': 'Únete a un convoy o crea el tuyo. Comparte el enlace.',
    'convoys.create': 'Nuevo convoy', 'convoys.empty': '¡Aún no hay convoyes. Sé el primero!',
    'convoys.online': 'pilotos en línea', 'convoys.online_others': 'más',
    'convoys.members': 'miembros', 'convoys.join': 'Unirse', 'convoys.joined': 'Unido',
    'convoys.leave': 'Salir', 'convoys.full': 'Lleno', 'convoys.share': 'Compartir', 'convoys.copied': '¡Enlace copiado!',
    'convoys.host': 'Anfitrión', 'convoys.season': 'Estación', 'convoys.delete': 'Eliminar', 'convoys.deleted': 'Convoy eliminado',
    'convoys.confirm_delete': '¿Eliminar este convoy?', 'convoys.scheduled': 'Programado',
    'convoys.must_login_create': 'Inicia sesión para crear un convoy.', 'convoys.must_login_join': 'Inicia sesión para unirte.',
    'convoys.launched': '¡Convoy lanzado!', 'convoys.crew': 'Tripulación', 'convoys.discussion': 'Discusión',
    'convoys.chat.placeholder': 'Coordínate con los pilotos...', 'convoys.chat.placeholder_disabled': 'Inicia sesión',
    'convoys.chat.empty': 'No hay mensajes.',
    'convoys.form.name': 'Nombre del convoy', 'convoys.form.desc': 'Descripción (objetivo, coches, nivel)',
    'convoys.form.max': 'Capacidad máx. (incluye anfitrión)', 'convoys.form.submit': 'Lanzar el convoy',
    'convoys.not_found': 'Convoy no encontrado', 'convoys.joined_toast': '¡Unido!', 'convoys.left_toast': 'Salido',
    'profile.title': 'Mi perfil', 'profile.member_of': 'Miembro de Horizon.Meet&Cruise',
    'profile.go_map': 'Añadir un spot',
    'profile.stats.spots': 'Spots creados', 'profile.stats.meets': 'Car Meets',
    'profile.stats.photos': 'Spots foto', 'profile.stats.likes': 'Likes recibidos',
    'profile.my_spots': 'Mis spots',
    'profile.contributions_singular': 'contribución al mapa de FH6.',
    'profile.contributions_plural': 'contribuciones al mapa de FH6.',
    'profile.empty.title': 'Aún no hay spots', 'profile.empty.desc': 'Abre el mapa y coloca tu primer spot.',
    'profile.empty.cta': 'Abrir el mapa', 'profile.unavailable': 'Perfil no disponible.',
    'admin.title': 'Moderación', 'admin.logged_as': 'Conectado como',
    'admin.stats.users': 'Usuarios', 'admin.stats.spots': 'Spots', 'admin.stats.carmeet': 'Car Meets',
    'admin.stats.photo': 'Spots foto', 'admin.stats.comments': 'Comentarios',
    'admin.search': 'Filtrar por título, autor, email...',
    'admin.tab.spots': 'Spots', 'admin.tab.comments': 'Comentarios', 'admin.tab.users': 'Usuarios',
    'admin.confirm_delete_spot': 'Eliminar spot', 'admin.confirm_delete_comment': '¿Eliminar comentario?',
    'admin.col.username': 'Apodo', 'admin.col.email': 'Email', 'admin.col.role': 'Rol', 'admin.col.registered': 'Registro',
    'admin.reply_marker': 'respuesta',
        'landing.live.convoys': 'convoyes activos',
    'landing.live.online': 'pilotos en línea',
    'landing.convoys.title': 'Convoyes en vivo',
    'landing.convoys.subtitle': 'Únete a un convoy que sale ahora o lanza el tuyo desde la página dedicada.',
    'landing.convoys.cta': 'Ver todos los convoyes',
    'landing.convoys.empty': 'No hay convoyes activos. ¡Lanza el primero!',
    'landing.convoys.create': 'Nuevo convoy',
        'gamertag.title': 'Tu apodo in-game',
    'gamertag.desc': 'Antes de continuar, indica tu apodo de Forza Horizon 6 para que otros pilotos te reconozcan. Modificable luego.',
    'gamertag.field': 'Apodo in-game (Forza Horizon 6)',
    'gamertag.hint': '40 caracteres máx · nombre mostrado en todas partes',
    'gamertag.save': 'Continuar', 'gamertag.saved': 'Apodo guardado',
    'profile.avatar.change': 'Cambiar foto',
    'profile.avatar.saved': 'Foto de perfil actualizada',
    'profile.socials.title': 'Cuentas vinculadas',
    'profile.socials.subtitle': 'Muestra tus cuentas de Discord, Twitch, YouTube y TikTok en tu perfil.',
    'profile.socials.placeholder.discord': 'discord_user#0001',
    'profile.socials.placeholder.twitch': 'twitch.tv/tu_apodo',
    'profile.socials.placeholder.youtube': 'youtube.com/@tu_canal',
    'profile.socials.placeholder.tiktok': '@tu_tiktok',
    'profile.socials.saved': 'Cuentas actualizadas', 'profile.socials.save': 'Guardar',
    'profile.edit.gamer_tag': 'Apodo in-game', 'profile.edit.name': 'Nombre mostrado',
    'profile.edit.save': 'Guardar', 'profile.edit.saved': 'Perfil actualizado',
    'admin.edit_spot': 'Editar', 'admin.edit_spot.title': 'Editar spot',
    'admin.edit_spot.save': 'Guardar', 'admin.edit_spot.saved': 'Spot actualizado',
    'common.save': 'Guardar', 'common.cancel': 'Cancelar', 'common.delete': 'Eliminar',
    'common.loading': 'Cargando...', 'common.error': 'Error',
    'common.season.spring': 'Primavera', 'common.season.summer': 'Verano',
    'common.season.autumn': 'Otoño', 'common.season.winter': 'Invierno',
    'lang.label': 'Idioma',
  },
  it: {
    'nav.home': 'Home', 'nav.map': 'Mappa FH6', 'nav.convoys': 'Convogli',
    'nav.messages': 'Messaggi',
    'messages.title': 'Messaggi',
    'messages.tab.dms': 'Chat',
    'messages.tab.friends': 'Amici',
    'messages.empty_threads': 'Nessuna chat. Aggiungi un amico.',
    'messages.empty_conv': 'Invia il primo messaggio.',
    'messages.select_conv': 'Scegli una chat o un amico.',
    'messages.placeholder': 'Il tuo messaggio...',
    'messages.search_user': 'Cerca un pilota...',
    'messages.pending_in': 'Richieste ricevute',
    'messages.friends_count': 'Amici',
    'messages.no_friends': 'Nessun amico ancora.',
    'messages.request_sent': 'Richiesta inviata',
    'friend.add': 'Aggiungi',
    'friend.pending': 'In attesa',
    'friend.respond': 'Rispondi',
    'friend.message': 'Messaggio',
    'notif.friend_request': "ti ha inviato una richiesta d'amicizia",
    'chat.title': 'Messaggi',
    'chat.open': 'Apri chat',
    'chat.full_view': 'Vedi tutto', 'nav.about': 'Info',
    'chat.friends_convoys': 'Amici e convogli',
    'chat.my_convoy': 'Il mio convoglio',
    'chat.pilots': 'piloti',
    'chat.open_short': 'Apri',
    'chat.friend_requests': 'Richieste di amicizia',
    'chat.friends': 'Amici',
    'chat.no_friends': 'Ancora nessun amico.',
    'chat.following': 'Seguiti',
    'chat.unread_messages': 'Messaggi non letti',
    'chat.quick.messages': 'Messaggi',
    'chat.quick.messages_sub': 'Messaggi privati',
    'chat.quick.convoy': 'Chat del convoglio',
    'chat.quick.convoy_none': 'Nessun convoglio attivo',
    'welcome.title': 'Benvenuto su Horizon.Meet&Cruise',
    'welcome.subtitle': 'Unisciti alla community per segnare i tuoi spot, lanciare car meet e guidare in convoglio con altri piloti FH6.',
    'welcome.register': 'Crea un account',
    'welcome.login': 'Ho già un account',
    'welcome.later': 'Più tardi',
    'composer.add_image': 'Aggiungi immagine', 'composer.image_only': 'Solo immagini', 'composer.too_large': 'File troppo grande (8MB max)',
    'public_profile.spots_of': 'Spot di', 'public_profile.no_spots': 'Ancora nessuno spot.',
    'convoys.host.manage': 'Gestisci', 'convoys.host.kick_member': 'Espelli dal convoglio',
    'convoys.host.transfer_to': "Trasferisci l'host a", 'convoys.host.kick_confirm_title': 'Espellere questo pilota?',
    'convoys.host.kick_confirm_body': "Confermare l'espulsione di", 'convoys.host.transfer_confirm_title': "Trasferire il ruolo di host?",
    'convoys.host.transfer_confirm_body': 'Trasferire il ruolo a', 'convoys.host.kicked': 'Pilota espulso',
    'convoys.host.transferred': 'Host trasferito', 'convoys.host.banned': 'Bannati',
    'convoys.host.unban': 'Riammetti', 'convoys.host.unbanned': 'Pilota riammesso',
    'map.fullscreen': 'Schermo intero', 'map.exit_fullscreen': 'Esci da schermo intero',
    'map.signal_carmeet': 'Segnala Car Meet', 'map.live': 'live',
    'map.cat.live_carmeet': 'Car Meet (live)', 'map.cat.viewpoint': 'Punto panoramico',
    'map.cat.parking': 'Parcheggio', 'map.cat.gas': 'Distributore', 'map.cat.spot': 'Spot',
    'map.cat.s365': '365',
    'addspot.cat.viewpoint': 'Punto panoramico', 'addspot.cat.viewpoint_sub': 'Vista panoramica',
    'addspot.cat.parking': 'Parcheggio', 'addspot.cat.parking_sub': 'Posto auto',
    'addspot.cat.gas': 'Distributore', 'addspot.cat.gas_sub': 'Rifornimento / sosta',
    'addspot.cat.spot': 'Spot', 'addspot.cat.spot_sub': 'Posto interessante',
    'addspot.cat.s365': '365', 'addspot.cat.s365_sub': 'Negozio 24/7',
    'spot.start_livemeet': 'Avvia un car meet live qui',
    'spot.live_here': 'Car meet live qui',
    'livemeet.locked_on_spot': 'Posizione dello spot selezionato',
    'livemeet.joined_convoy': 'Richiesta di convoglio inviata',
    'livemeet.convoy_full': 'Convoglio pieno',
    'livemeet.join_convoy': 'Chiedi di unirti',
    'livemeet.stop_btn': 'Ferma il car meet live',
    'livemeet.confirm_stop': 'Fermare questo car meet live? Il convoglio rimarrà attivo.',
    'livemeet.stopped': 'Car meet live fermato',
    'convoys.chat.members_only': 'Solo membri',
    'common.error': 'Si è verificato un errore',
    'map.by': 'di',
    'addspot.placeholder.title': 'Scogliera del tramonto', 'addspot.placeholder.desc': 'Ora dorata, accesso facile, parcheggio per 5 auto...',
    'admin.edit_spot.image': 'Screenshot', 'admin.edit_spot.upload_cta': 'Sostituisci screenshot',
    'nav.leaderboard': 'Classifica',
    'nav.media': 'Media',
    'media.label': 'Spazio Media', 'media.title': 'Condividi i tuoi scatti migliori',
    'media.subtitle': 'Foto, video, clip YouTube/Twitch. Metti like, commenta, reagisci.',
    'media.tab.posts': 'Pubblicazioni', 'media.tab.from_spots': 'Dagli spot',
    'media.new_post': 'Nuova pubblicazione', 'media.publish': 'Pubblica',
    'media.empty': 'Nessuna pubblicazione.', 'media.confirm_delete': 'Eliminare questa pubblicazione?',
    'leaderboard.title': 'Classifica', 'leaderboard.subtitle': 'I migliori piloti della community Horizon.Meet&Cruise.',
    'leaderboard.formula': 'Formula', 'leaderboard.spots': 'Spot', 'leaderboard.hosted': 'Host',
    'leaderboard.joined': 'Convogli', 'leaderboard.likes': 'Like', 'leaderboard.score': 'Punteggio',
    'leaderboard.driver': 'Pilota', 'leaderboard.empty': 'Nessun pilota classificato.',
    'leaderboard.followers': 'Follower', 'leaderboard.sort_by': 'Ordina per',
    'follow.follow': 'Segui', 'follow.following': 'Stai seguendo',
    'follow.followed': 'Ora segui', 'follow.unfollowed': 'Hai smesso di seguire',
    'livemeet.title': 'Car Meet live', 'livemeet.desc': 'Avvisa gli altri piloti che stai organizzando un car meet adesso.',
    'livemeet.field.title': 'Titolo del meet', 'livemeet.placeholder': 'Late night drift @ Tokyo',
    'livemeet.coords_set': 'Posizione pronta', 'livemeet.pick_on_map': 'Clicca sulla mappa per scegliere il punto',
    'livemeet.pick_first': 'Prima scegli un punto sulla mappa.', 'livemeet.pick_banner': 'Clicca sulla mappa per piazzare il tuo car meet',
    'livemeet.ttl_hint': 'Visibile 4h o finché non lo fermi.',
    'livemeet.broadcast': 'Trasmetti meet', 'livemeet.created': 'Car meet trasmesso!',
    'livemeet.default_title': 'Car meet in corso',
    'livemeet.expires_at': 'Termina alle', 'livemeet.stop': 'Ferma il mio car meet',
    'livemeet.stop_confirm': 'Fermare il tuo car meet live?', 'livemeet.stopped': 'Car meet fermato',
    'livemeet.admin_delete': 'Elimina (admin)', 'livemeet.deleted': 'Car meet eliminato',
    'livemeet.field.convoy': 'Collega un convoglio', 'livemeet.no_convoy': 'Nessun convoglio collegato',
    'livemeet.convoy_hint': "I piloti potranno unirsi al tuo convoglio direttamente dalla mappa.",
    'livemeet.linked_convoy': 'Convoglio collegato', 'livemeet.join_convoy': 'Unisciti al convoglio',
    'livemeet.joined_convoy': 'Convoglio raggiunto!', 'livemeet.convoy_full': 'Convoglio pieno',
    'convoys.members': 'membri',
    'common.confirm': 'Conferma', 'common.cancel': 'Annulla',
    'nav.login': 'Accedi', 'nav.logout': 'Esci', 'nav.profile': 'Profilo', 'nav.admin': 'Moderazione',
    'auth.title.login': 'Accedi', 'auth.title.register': 'Crea account',
    'auth.desc': 'Unisciti alla community FH6. Aggiungi spot, metti like e commenta.',
    'auth.tab.login': 'Accedi', 'auth.tab.register': 'Registrati',
    'auth.name': 'Nome', 'auth.email': 'Email', 'auth.password': 'Password',
    'auth.submit.login': 'Accedi', 'auth.submit.register': 'Registrati',
    'auth.discord': 'Continua con Discord', 'auth.or': 'oppure',
    'auth.welcome_back': 'Benvenuto!', 'auth.account_created': 'Account creato.',
    'auth.must_login': 'Accedi per continuare.',
    'hero.tag': 'Community · Spot · Convogli · Foto',
    'hero.title.line1': 'La mappa di', 'hero.title.line2': 'segnata da te.',
    'hero.subtitle': 'Segna i migliori spot della mappa di FH6, condividili con la community e avvia i tuoi car meet e convogli live per guidare insieme.',
    'hero.cta.map': 'Apri la mappa', 'hero.cta.convoys': 'Vedi i convogli', 'hero.cta.about': 'Come funziona',
    'hero.stats.map': 'Mappa 4K', 'hero.stats.map_sub': 'satellite',
    'hero.stats.photos': 'Spot foto', 'hero.stats.photos_sub': 'condivisi',
    'hero.stats.meets': 'Car meet', 'hero.stats.meets_sub': 'community',
    'hero.stats.likes': 'Like & recensioni', 'hero.stats.likes_sub': 'Statistica',
    'landing.terrains.title1': 'Un terreno di gioco,', 'landing.terrains.title2': 'tre universi.',
    'landing.terrains.subtitle': 'Dai picchi innevati ai porti industriali. Ogni angolo ha il suo spot.',
    'landing.terrains.mountains.t': 'Cime innevate', 'landing.terrains.mountains.d': 'Passi di montagna, drift sulla neve.',
    'landing.terrains.forests.t': 'Foreste & valli', 'landing.terrains.forests.d': 'Strade tortuose tra i pini.',
    'landing.terrains.city.t': 'Metropoli & porto', 'landing.terrains.city.d': 'Tunnel al neon, autostrade urbane.',
    'landing.how.tag': 'Come funziona', 'landing.how.title': 'Quattro passaggi. Zero attrito.',
    'landing.how.s1.t': 'Apri la mappa', 'landing.how.s1.d': 'Clicca "Apri la mappa".',
    'landing.how.s2.t': 'Aggiungi un marker', 'landing.how.s2.d': 'Crea uno spot (parcheggio, panorama, 365, ecc.) con screenshot. Poi puoi avviare un car meet live direttamente da quello spot — o posizionarne uno liberamente ovunque sulla mappa.',
    'landing.how.s3.t': 'Esplora', 'landing.how.s3.d': 'Metti like, commenta, unisciti a un convoglio e passeggia da uno spot all\'altro per scoprire i posti migliori della community.',
    'landing.how.s4.t': 'Lancia un convoglio',
    'landing.how.s4.d': 'Crea un convoglio sulla pagina dedicata e guidate insieme in tempo reale. Importante: questo sito non è collegato al gioco — invita i tuoi amici direttamente da Forza Horizon 6.',
    'landing.creator.title': 'Supporta il creator',
    'landing.creator.discord_join': 'Entra nel server',
    'landing.creator.subtitle': 'Trova Ochibi sulle sue altre piattaforme.',
    'landing.cta.enter': 'Apri la mappa FH6',
    'landing.featured.year': 'Summer · 2026', 'landing.featured.cta': 'Apri la mappa',
    'map.back_home': 'Home', 'map.search_placeholder': 'Cerca uno spot...', 'map.filters': 'Filtri',
    'map.cat.carmeet': 'Car Meet', 'map.cat.photo': 'Spot Foto', 'map.spots_count': 'Spot',
    'map.empty_logged_in': 'Nessuno spot. Sii il primo!', 'map.empty_logged_out': 'Nessuno spot. Accedi.',
    'map.tip': 'Attiva "Aggiungi uno spot" e clicca sulla mappa.',
    'map.tip_strong': 'Aggiungi uno spot', 'map.add_spot': 'Aggiungi uno spot', 'map.cancel': 'Annulla',
    'map.click_to_place': 'Clicca sulla mappa per posizionare il tuo spot',
    'map.legend.carmeet': 'Car Meet', 'map.legend.photo': 'Spot Foto',
    'map.online_now': 'online',
    'map.live_convoys': 'convogli attivi',
    'map.hide_sidebar': 'Nascondi filtri',
    'map.show_sidebar': 'Mostra filtri',
    'addspot.title': 'Nuovo spot', 'addspot.desc': 'Descrivi il luogo e scegli la categoria.',
    'addspot.cat.carmeet': 'Car Meet', 'addspot.cat.carmeet_sub': 'Punto d\'incontro',
    'addspot.cat.photo': 'Spot Foto', 'addspot.cat.photo_sub': 'Punto panoramico',
    'addspot.field.title': 'Titolo', 'addspot.field.desc': 'Descrizione (opzionale)',
    'addspot.upload.title': 'Screenshot (opzionale)', 'addspot.upload.cta': 'Trascina o clicca per caricare',
    'addspot.upload.hint': 'JPG · PNG · WEBP · 8MB max', 'addspot.submit': 'Pubblica lo spot',
    'addspot.created': 'Spot aggiunto!',
    'spot.by': 'da', 'spot.likes': 'like', 'spot.like_singular': 'like',
    'spot.comments_count': 'commento', 'spot.comments_count_plural': 'commenti',
    'spot.delete': 'Elimina questo spot', 'spot.moderate_admin': 'Modera (admin)',
    'spot.deleted': 'Spot eliminato', 'spot.confirm_delete': 'Eliminare questo spot?',
    'spot.comments.title': 'Commenti', 'spot.comments.placeholder': 'Lascia un commento...',
    'spot.comments.placeholder_disabled': 'Accedi per commentare', 'spot.comments.empty': 'Sii il primo!',
    'spot.comment.reply': 'Rispondi', 'spot.comment.cancel': 'Annulla', 'spot.comment.like': 'Mi piace',
    'spot.comment.reply_to': 'Rispondi a', 'spot.comment.deleted': 'Commento eliminato',
    'spot.comment.confirm_delete': 'Eliminare questo commento?',
    'convoys.title': 'Convogli attivi',
    'convoys.subtitle': 'Unisciti a un convoglio o crea il tuo. Condividi il link.',
    'convoys.create': 'Nuovo convoglio', 'convoys.empty': 'Nessun convoglio. Sii il primo!',
    'convoys.online': 'piloti online', 'convoys.online_others': 'altri',
    'convoys.members': 'membri', 'convoys.join': 'Entra', 'convoys.joined': 'Entrato',
    'convoys.leave': 'Esci', 'convoys.full': 'Pieno', 'convoys.share': 'Condividi', 'convoys.copied': 'Link copiato!',
    'convoys.host': 'Host', 'convoys.season': 'Stagione', 'convoys.delete': 'Elimina', 'convoys.deleted': 'Convoglio eliminato',
    'convoys.confirm_delete': 'Eliminare questo convoglio?', 'convoys.scheduled': 'Programmato',
    'convoys.must_login_create': 'Accedi per creare un convoglio.', 'convoys.must_login_join': 'Accedi per unirti.',
    'convoys.launched': 'Convoglio lanciato!', 'convoys.crew': 'Equipaggio', 'convoys.discussion': 'Discussione',
    'convoys.chat.placeholder': 'Coordinati con i piloti...', 'convoys.chat.placeholder_disabled': 'Accedi',
    'convoys.chat.empty': 'Nessun messaggio.',
    'convoys.form.name': 'Nome convoglio', 'convoys.form.desc': 'Descrizione (obiettivo, auto, livello)',
    'convoys.form.max': 'Capacità max (host incluso)', 'convoys.form.submit': 'Lancia il convoglio',
    'convoys.not_found': 'Convoglio non trovato', 'convoys.joined_toast': 'Entrato!', 'convoys.left_toast': 'Uscito',
    'profile.title': 'Profilo', 'profile.member_of': 'Membro di Horizon.Meet&Cruise',
    'profile.go_map': 'Aggiungi uno spot',
    'profile.stats.spots': 'Spot creati', 'profile.stats.meets': 'Car Meet',
    'profile.stats.photos': 'Spot Foto', 'profile.stats.likes': 'Like ricevuti',
    'profile.my_spots': 'I miei spot',
    'profile.contributions_singular': 'contributo alla mappa FH6.',
    'profile.contributions_plural': 'contributi alla mappa FH6.',
    'profile.empty.title': 'Nessuno spot', 'profile.empty.desc': 'Apri la mappa e aggiungi il tuo primo spot.',
    'profile.empty.cta': 'Apri la mappa', 'profile.unavailable': 'Profilo non disponibile.',
    'admin.title': 'Moderazione', 'admin.logged_as': 'Connesso come',
    'admin.stats.users': 'Utenti', 'admin.stats.spots': 'Spot', 'admin.stats.carmeet': 'Car Meet',
    'admin.stats.photo': 'Spot Foto', 'admin.stats.comments': 'Commenti',
    'admin.search': 'Filtra per titolo, autore, email...',
    'admin.tab.spots': 'Spot', 'admin.tab.comments': 'Commenti', 'admin.tab.users': 'Utenti',
    'admin.confirm_delete_spot': 'Eliminare lo spot', 'admin.confirm_delete_comment': 'Eliminare il commento?',
    'admin.col.username': 'Nome', 'admin.col.email': 'Email', 'admin.col.role': 'Ruolo', 'admin.col.registered': 'Registrato',
    'admin.reply_marker': 'risposta',
        'landing.live.convoys': 'convogli attivi',
    'landing.live.online': 'piloti online',
    'landing.convoys.title': 'Convogli in diretta',
    'landing.convoys.subtitle': 'Unisciti a un convoglio in partenza o lancia il tuo dalla pagina dedicata.',
    'landing.convoys.cta': 'Vedi tutti i convogli',
    'landing.convoys.empty': 'Nessun convoglio attivo. Lancia il primo!',
    'landing.convoys.create': 'Nuovo convoglio',
        'gamertag.title': 'Il tuo tag in-game',
    'gamertag.desc': 'Inserisci il tuo tag Forza Horizon 6 per essere riconosciuto dagli altri piloti. Modificabile.',
    'gamertag.field': 'Tag in-game (Forza Horizon 6)',
    'gamertag.hint': '40 caratteri max · nome visualizzato ovunque', 'gamertag.save': 'Continua', 'gamertag.saved': 'Tag salvato',
    'profile.avatar.change': 'Cambia foto',
    'profile.avatar.saved': 'Foto profilo aggiornata',
    'profile.socials.title': 'Account collegati',
    'profile.socials.subtitle': 'Mostra i tuoi account Discord, Twitch, YouTube e TikTok sul profilo.',
    'profile.socials.placeholder.discord': 'discord_user#0001',
    'profile.socials.placeholder.twitch': 'twitch.tv/tuo_handle',
    'profile.socials.placeholder.youtube': 'youtube.com/@tuo_canale',
    'profile.socials.placeholder.tiktok': '@tuo_tiktok',
    'profile.socials.saved': 'Account aggiornati', 'profile.socials.save': 'Salva',
    'profile.edit.gamer_tag': 'Tag in-game', 'profile.edit.name': 'Nome visualizzato',
    'profile.edit.save': 'Salva', 'profile.edit.saved': 'Profilo aggiornato',
    'admin.edit_spot': 'Modifica', 'admin.edit_spot.title': 'Modifica spot',
    'admin.edit_spot.save': 'Salva', 'admin.edit_spot.saved': 'Spot aggiornato',
    'common.save': 'Salva', 'common.cancel': 'Annulla', 'common.delete': 'Elimina',
    'common.loading': 'Caricamento...', 'common.error': 'Errore',
    'common.season.spring': 'Primavera', 'common.season.summer': 'Estate',
    'common.season.autumn': 'Autunno', 'common.season.winter': 'Inverno',
    'lang.label': 'Lingua',
  },
};

export const LANGUAGES = [
  { code: 'fr', label: 'Français', flag: '🇫🇷' },
  { code: 'en', label: 'English',  flag: '🇬🇧' },
  { code: 'de', label: 'Deutsch',  flag: '🇩🇪' },
  { code: 'es', label: 'Español',  flag: '🇪🇸' },
  { code: 'it', label: 'Italiano', flag: '🇮🇹' },
];

const I18nCtx = createContext({ lang: 'fr', t: (k) => k, setLang: () => {} });

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    try { return localStorage.getItem('hm_lang') || 'fr'; } catch { return 'fr'; }
  });

  const setLang = (l) => {
    setLangState(l);
    try { localStorage.setItem('hm_lang', l); } catch {}
  };

  useEffect(() => { document.documentElement.lang = lang; }, [lang]);

  const value = useMemo(() => {
    const map = dict[lang] || dict.fr;
    const t = (key, fallback) => map[key] || (dict.fr[key] || fallback || key);
    return { lang, setLang, t };
  }, [lang]);

  return <I18nCtx.Provider value={value}>{children}</I18nCtx.Provider>;
}

export const useI18n = () => useContext(I18nCtx);
